import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import { useHistory } from "react-router-dom";
import { Facebook, Instagram, WhatsApp, LinkedIn, PersonAdd } from "@material-ui/icons";
import { Avatar, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, Drawer, IconButton, Menu, MenuItem, Popover, Portal, Select, TextField, Typography, Button } from "@material-ui/core";
import AppTooltip from "../../components/AppTooltip";
import { format, isSameDay, parseISO } from "date-fns";
import FilterButton from "../../components/FilterButton";
import TicketsQueueSelect from "../../components/TicketsQueueSelect";
import { TagsFilter } from "../../components/TagsFilter";
import { WhatsappsFilter } from "../../components/WhatsappsFilter";
import { StatusFilter } from "../../components/StatusFilter";
import { UsersFilter } from "../../components/UsersFilter";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import ReactCountryFlag from "react-country-flag";
import {
  GitBranch,
  UserRound,
  ArrowUpRight,
  X as LuX,
  Tag as TagIcon,
  Radio,
  Pencil,
  Kanban as KanbanIcon,
  MessageCircleMore,
  UsersRound,
  GripVertical,
  NotebookPen,
  MessageSquare,
  CalendarDays,
  RotateCcw,
  Clock,
  User as UserSolidIcon,
  DollarSign,
  Bell as BellLucide,
  BellOff as BellOffLucide,
  Filter as FilterIcon,
} from "lucide-react";

const MessageCircleCheck = ({ size = 18, strokeWidth = 1.5, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
import useActionBtnStyles from "../../styles/actionBtnStyles";
import TransferTicketModalCustom from "../../components/TransferTicketModalCustom";
import { parsePhoneNumber } from "libphonenumber-js";
import ContactDrawer from "../../components/ContactDrawer";
import { TagsContainer } from "../../components/TagsContainer";
import ChatiaPopover from "../../components/ChatiaPopover";
import ChatiaDialog from "../../components/ChatiaDialog";
import AddColumnPopover from "../../components/AddColumnPopover";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import ContactAvatar from "../../components/ContactAvatar";
import { maskTitleIfPhone } from "../../utils/maskSensitive";
import { useSearch } from "../../context/Search/SearchContext";
import Ticket from "../../components/Ticket";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import ChatiaSelect from "../../components/ChatiaSelect";
import ScheduleModal from "../../components/ScheduleModal";
import DatePickerCustom from "../../components/DatePickerCustom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import whatsappIcon from "../../assets/whatsapp.png";
import facebookIcon from "../../assets/facebook.png";
import instagramIcon from "../../assets/instagram.png";
import useCurrency, { maskCurrencyInput, unmaskCurrencyInput } from "../../hooks/useCurrency";

/* ─── keyframes ───────────────────────────────────── */
if (!document.getElementById("kanban-pulse-keyframes")) {
  const style = document.createElement("style");
  style.id = "kanban-pulse-keyframes";
  style.textContent = `@keyframes tagPulse { 0% { transform: scale(1); opacity: 0.4; } 50% { transform: scale(2.2); opacity: 0; } 100% { transform: scale(1); opacity: 0.4; } } @keyframes tagPulseSmall { 0% { transform: scale(1); opacity: 0.35; } 50% { transform: scale(1.6); opacity: 0; } 100% { transform: scale(1); opacity: 0.35; } }`;
  document.head.appendChild(style);
}

/* ─── checkbox (padrão /contacts) ──────────────────── */
const CheckboxUnchecked = () => (
  <span style={{ width: 16, height: 16, borderRadius: 4, border: "1.5px solid color-mix(in srgb, rgba(150,150,150,0.5) 40%, transparent)", display: "block" }} />
);
const CheckboxChecked = () => (
  <span style={{ width: 16, height: 16, borderRadius: 4, border: "1.5px solid #06cf9c", backgroundColor: "#06cf9c", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M5 14L8.5 17.5L19 6.5" /></svg>
  </span>
);

/* ─── helpers ──────────────────────────────────────── */
const fmtMoney = (v) => {
  const n = Number(v);
  if (!n && n !== 0) return null;
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

/* ─── tiny SVG icons ───────────────────────────────── */
const DragIcon = (props) => (
  <GripVertical size={14} strokeWidth={1.5} style={{ opacity: 0.4, ...(props?.style || {}) }} {...props} />
);
const NotesIcon = (props) => (
  <NotebookPen size={16} strokeWidth={1.5} {...props} />
);
const ChatIcon = (props) => (
  <MessageSquare size={16} strokeWidth={1.5} {...props} />
);
const ScheduleIcon = (props) => (
  <CalendarDays size={16} strokeWidth={1.5} {...props} />
);
const FollowUpIconSvg = (props) => (
  <RotateCcw size={16} strokeWidth={1.5} {...props} />
);
const ClockSmall = (props) => (
  <Clock size={12} strokeWidth={2} style={{ opacity: 0.5, flexShrink: 0, ...(props?.style || {}) }} {...props} />
);
const PersonIcon = (props) => (
  <UserSolidIcon size={16} strokeWidth={1.5} style={{ opacity: 0.45, ...(props?.style || {}) }} {...props} />
);
const ChannelIcon = ({ channel, size = 13 }) => {
  const map = {
    whatsapp: <WhatsApp style={{ color: "#25D366", fontSize: size }} />,
    facebook: <Facebook style={{ color: "#1877F2", fontSize: size }} />,
    instagram: <Instagram style={{ color: "#E1306C", fontSize: size }} />,
    linkedin: <LinkedIn style={{ color: "#0A66C2", fontSize: size }} />,
    indicacao: <PersonAdd style={{ color: "#10b981", fontSize: size }} />,
  };
  return map[channel] || null;
};

const getLeadSourceLabel = (source) => {
  const map = {
    whatsapp: "WhatsApp",
    facebook: "Facebook",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    indicacao: i18n.t("kanban.leadSource.indicacao"),
  };
  return map[source];
};

const DollarIcon = (props) => (
  <DollarSign size={16} strokeWidth={1.5} {...props} />
);

const BellIcon = (props) => (
  <BellLucide size={13} strokeWidth={1.5} {...props} />
);
const BellOffIcon = (props) => (
  <BellOffLucide size={13} strokeWidth={1.5} {...props} />
);

/* ─── styles ───────────────────────────────────────── */
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
    flex: 1,
    minHeight: 0,
    height: "100%",
    overflow: "hidden",
    "&:fullscreen": {
      height: "100vh",
      background: "#111",
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    marginBottom: 10,
    flexShrink: 0,
  },
  customCheckbox: {
    padding: 4,
    "& .MuiSvgIcon-root": { display: "none" },
    "&:hover": { backgroundColor: "transparent !important" },
  },
  boardsBar: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    flexWrap: "wrap",
  },
  boardChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 12px",
    fontSize: 13,
    fontWeight: 500,
    cursor: "pointer",
    outline: "none",
    borderRadius: "10px",
    border: "1px solid " + (theme.mode === "light" ? "rgba(0,0,0,0.12)" : "rgba(255,255,255,0.12)"),
    background: "transparent",
    color: "inherit",
    transition: "all 0.15s ease",
    "&:hover": {
      background: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.05)",
    },
  },
  boardChipActive: {
    background: "" + theme.palette.primary.main + " !important",
    borderColor: "" + theme.palette.primary.main + " !important",
    color: "#fff !important",
  },
  boardSelectWrap: {
    "& .MuiFormControl-root": {
      minWidth: 180,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px !important",
      fontSize: 13,
      fontWeight: 500,
      background: "color-mix(in srgb, " + theme.palette.primary.main + " 100%, transparent) !important",
      border: "1px solid color-mix(in srgb, " + theme.palette.primary.main + " 30%, transparent) !important",
      transition: "all 0.15s ease",
      "&:hover": {
        filter: "brightness(1.1)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiSelect-select, & .MuiSelect-root": {
      padding: "6px 32px 6px 14px !important",
    },
    "& .MuiOutlinedInput-root, & .MuiSelect-root, & .MuiInputBase-input, & .MuiSelect-outlined, & .MuiSelect-select.MuiSelect-select": {
      color: "#fff !important",
    },
    "& .MuiSelect-icon, & .MuiSelect-icon.MuiSelect-icon": {
      color: "#fff !important",
    },
  },
  leftHeaderGroup: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
  },
  filterTriggerBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle",
    gap: 6,
    height: 36,
    minWidth: 64,
    padding: "0 16px",
    borderRadius: 12,
    border: "none",
    boxSizing: "border-box",
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText || "#fff",
    fontFamily: "inherit",
    fontSize: 13.5,
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: 0.4,
    lineHeight: 1.75,
    cursor: "pointer",
    boxShadow: "0 3px 1px -2px rgba(0,0,0,0.2),0 2px 2px 0 rgba(0,0,0,0.14),0 1px 5px 0 rgba(0,0,0,0.12)",
    transition: "background-color 250ms cubic-bezier(0.4,0,0.2,1), box-shadow 250ms cubic-bezier(0.4,0,0.2,1)",
    "&:hover": {
      background: theme.palette.primary.dark || theme.palette.primary.main,
    },
  },
  filterCountBadge: {
    marginLeft: 4,
    padding: "1px 7px",
    borderRadius: 999,
    background: "rgba(255,255,255,0.22)",
    fontSize: 11,
    fontWeight: 700,
  },
  filterDrawerPaper: {
    width: 360,
    [theme.breakpoints.down("xs")]: { width: "85vw" },
    backgroundColor: theme.mode === "dark" ? "#121212" : "#fff",
    backgroundImage: "none",
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
    overflow: "hidden",
  },
  filterDrawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 16px",
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText || "#fff",
    flex: "0 0 auto",
  },
  filterDrawerTitle: {
    fontWeight: 600,
    fontSize: 15,
    color: "inherit",
  },
  filterDrawerClose: {
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    color: "#fff",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.22)",
      color: "#fff",
    },
  },
  filterDrawerContent: {
    flex: "1 1 auto",
    overflowY: "auto",
    padding: theme.spacing(1, 0.5),
    ...theme.scrollbarStyles,
    "& .MuiOutlinedInput-root": { borderRadius: 12 },
    "& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root": { borderRadius: "12px !important" },
  },
  filterSectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    color: theme.mode === "dark" ? "#8696a0" : "#5a6a7a",
    padding: theme.spacing(1, 1.5, 0.5),
  },
  filterDrawerFooter: {
    flex: "0 0 auto",
    padding: "10px 14px",
    borderTop: `1px solid ${theme.mode === "dark" ? "#202632" : "#e8e8e8"}`,
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
  },
  board: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    flex: 1,
    minHeight: 0,
    overflowX: "auto",
    overflowY: "hidden",
    padding: "0 2px 8px",
    ...theme.scrollbarStyles,
  },

  /* ── lane ── */
  lane: {
    width: 275,
    minWidth: 275,
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    background: "color-mix(in srgb, " + (theme.mode === "light" ? "#fff" : "#1a1a1a") + " 55%, transparent)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    border: "1px solid " + (theme.mode === "light" ? "#e0e0e0" : "#333") + "",
    borderRadius: "12px",
    color: theme.mode === "light" ? "#111b21" : "#e9edef",
    maxHeight: "100%",
    minHeight: 0,
  },
  laneHeader: {
    padding: "12px 14px 10px",
    flexShrink: 0,
  },
  laneHeaderTop: {
    display: "flex",
    alignItems: "center",
    gap: 5,
  },
  laneDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    flexShrink: 0,
  },
  laneName: {
    fontWeight: 600,
    fontSize: 14,
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  laneCount: {
    background: `color-mix(in srgb, ${theme.palette.primary?.main || "#1976d2"} 14%, transparent)`,
    color: theme.palette.primary?.main || "#1976d2",
    borderRadius: 10,
    padding: "1px 8px",
    fontSize: 11,
    fontWeight: 600,
    flexShrink: 0,
  },
  laneMenuBtn: {
    padding: 2,
    color: "inherit",
    opacity: theme.mode === "light" ? 0.55 : 0.4,
    "&:hover": { opacity: 1 },
  },
  laneValue: {
    fontSize: 13,
    fontWeight: 500,
    opacity: theme.mode === "light" ? 0.7 : 0.55,
    marginTop: 2,
    paddingLeft: 18,
  },
  laneDivider: {
    height: 1,
    background: "" + (theme.mode === "light" ? "#e0e0e0" : "#333") + "",
    margin: "0 14px",
    flexShrink: 0,
  },
  cardPlaceholder: {
    borderRadius: "13px",
    background: theme.mode === "light" ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.06)",
    border: "2px dashed " + (theme.mode === "light" ? "rgba(0,0,0,0.12)" : "rgba(255,255,255,0.12)"),
    minHeight: 80,
    transition: "none",
  },
  laneCards: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    padding: "8px 10px",
    display: "flex",
    flexDirection: "column",
    gap: 8,
    ...theme.scrollbarStyles,
  },
  laneFooter: {
    padding: "6px 12px 12px",
    flexShrink: 0,
    display: "flex",
    justifyContent: "center",
  },
  addCardBtn: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "5px 14px",
    border: "1px dashed " + (theme.mode === "light" ? "rgba(0,0,0,0.15)" : "rgba(255,255,255,0.12)"),
    borderRadius: 8,
    background: "transparent",
    color: "inherit",
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 500,
    opacity: 0.45,
    transition: "all 0.15s",
    "&:hover": {
      opacity: 0.75,
      background: theme.mode === "light" ? "rgba(0,0,0,0.03)" : "rgba(255,255,255,0.04)",
    },
  },

  /* ── card ── */
  card: {
    background: "color-mix(in srgb, " + (theme.mode === "light" ? "#fff" : "#1a1a1a") + " 72%, transparent)",
    border: "1px solid " + (theme.mode === "light" ? "#eee" : "#2a2a2a") + "",
    borderRadius: "13px",
    padding: "10px 12px",
    cursor: "grab",
    transition: "box-shadow 0.15s, border-color 0.15s, transform 0.15s",
    color: theme.mode === "light" ? "#111b21" : "#e9edef",
    "&:active": {
      cursor: "grabbing",
    },
    "&:hover": {
      boxShadow: "0 3px 12px rgba(0,0,0,0.1)",
    },
    "&:hover $cardMoveArrow": {
      opacity: 0.5,
    },
  },
  cardDragging: {
    opacity: 0.5,
    transform: "rotate(2deg)",
    cursor: "grabbing !important",
  },
  cardTopRow: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  cardDrag: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
  },
  cardName: {
    fontWeight: 600,
    fontSize: 13,
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  cardValue: {
    fontWeight: 600,
    fontSize: 12,
    flexShrink: 0,
    opacity: 0.8,
  },
  cardInfo: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  cardNameRow: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  cardLastMsg: {
    fontSize: 11,
    opacity: theme.mode === "light" ? 0.65 : 0.5,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  cardTags: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 3,
    marginTop: 4,
    position: "relative",
    paddingRight: 20,
  },
  cardMoveArrow: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 2,
    borderRadius: "50%",
    cursor: "pointer",
    color: "inherit",
    opacity: 0,
    border: "none",
    background: "transparent",
    flexShrink: 0,
    transition: "opacity 0.15s",
    "&:hover": {
      opacity: 1,
      background: theme.mode === "light" ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.1)",
    },
  },
  cardTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    padding: "0px 4px",
    fontWeight: 600,
    borderRadius: 20,
    fontSize: "7.5px",
    whiteSpace: "nowrap",
    lineHeight: "14px",
    border: "1px solid currentColor",
  },
  cardTagLabel: {
    color: "inherit",
    opacity: 1,
    position: "relative",
    top: 1,
    filter: theme.mode === "light" ? "brightness(0.55)" : "none",
  },
  cardAvatarWrap: {
    position: "relative",
    width: 44,
    height: 44,
    flexShrink: 0,
  },
  cardContactAvatar: {
    width: 44,
    height: 44,
    fontSize: 15,
    fontWeight: 600,
  },
  cardFlag: {
    position: "absolute",
    bottom: -2,
    right: -2,
    lineHeight: 0,
    borderRadius: 2,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
  },
  cardLeftCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 4,
    flexShrink: 0,
    alignSelf: "flex-start",
    paddingTop: 2,
  },
  cardActionsRow: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    marginTop: 6,
  },
  cardTime: {
    fontSize: 10,
    opacity: theme.mode === "light" ? 0.55 : 0.4,
    whiteSpace: "nowrap",
    marginLeft: "auto",
  },
  cardActionBtn: {
    padding: 5,
    borderRadius: "50%",
    border: "none",
    background: "transparent",
    color: "inherit",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: theme.mode === "light" ? 0.55 : 0.4,
    transition: "all 0.15s",
    "&:hover": {
      opacity: 1,
      background: theme.mode === "light" ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.1)",
    },
  },
  cardMenuBtn: {
    position: "absolute",
    top: 6,
    right: 6,
    padding: 3,
    color: "inherit",
    opacity: 0.5,
    zIndex: 2,
    "&:hover": {
      opacity: 1,
      background: theme.mode === "light" ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.1)",
    },
  },
  contactDrawer: {
    "& .MuiDrawer-paper": {
      ...theme.chatiaDS.dialogPaper,
      width: 380,
      maxWidth: "85vw",
      maxHeight: "none !important",
      height: "100%",
      backgroundColor: theme.mode === "light" ? "#ffffff !important" : "#121212 !important",
      backgroundImage: "none !important",
      borderRadius: "21px 0 0 12px !important",
      border: "none",
      boxShadow: "-4px 0 24px rgba(0,0,0,0.15)",
    },
  },
  contactDrawerHeader: {
    ...theme.chatiaDS.header,
  },
  contactDrawerTitle: {
    ...theme.chatiaDS.headerTitle,
  },
  contactDrawerClose: {
    backgroundColor: theme.chatiaDS.closeButton.backgroundColor,
    color: theme.chatiaDS.closeButton.color,
    transition: theme.chatiaDS.closeButton.transition,
  },

  /* ── scroll nav arrows ── */
  boardWrapper: {
    position: "relative",
    flex: 1,
    minHeight: 0,
    display: "flex",
    overflow: "hidden",
  },
  scrollArrow: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: 18,
    height: 80,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: `color-mix(in srgb, ${theme.palette.primary?.main || "#1976d2"} 15%, transparent)`,
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    border: `1.5px solid ${theme.palette.primary?.main || "#1976d2"}`,
    cursor: "pointer",
    color: theme.palette.primary?.main || "#1976d2",
    padding: 0,
    transition: "opacity 0.2s, background 0.2s",
    "&:hover": {
      background: `color-mix(in srgb, ${theme.palette.primary?.main || "#1976d2"} 75%, transparent)`,
      color: "#fff",
    },
  },
  scrollArrowLeft: {
    left: 0,
    borderRadius: "0 10px 10px 0",
    borderLeft: "none",
  },
  scrollArrowRight: {
    right: 0,
    borderRadius: "10px 0 0 10px",
    borderRight: "none",
  },
  scrollArrowVisible: {
    opacity: 0.7,
    "&:hover": {
      opacity: 1,
      background: `color-mix(in srgb, ${theme.palette.primary?.main || "#1976d2"} 75%, transparent)`,
    },
  },
}));

/* ════════════════════════════════════════════════════════
   Component
   ════════════════════════════════════════════════════════ */
const Kanban = () => {
  const classes = useStyles();
  const actionBtnClasses = useActionBtnStyles();
  const theme = useTheme();
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);
  const { formatCurrency, getCurrency, getAvailableCurrencies, updateCurrency, currency } = useCurrency();

  useEffect(() => { getCurrency(); }, []);

  const [tags, setTags] = useState([]);
  const [tickets, setTickets] = useState([]);

  const [boards, setBoards] = useState([]);
  const [activeBoardId, setActiveBoardId] = useState(() => {
    try {
      const raw = localStorage.getItem(`kanban-active-board-${user.companyId}`);
      return raw ? Number(raw) : null;
    } catch { return null; }
  });
  const [newBoardPopover, setNewBoardPopover] = useState({ open: false, anchorEl: null });
  const [newBoardName, setNewBoardName] = useState("");
  const [newBoardTemplate, setNewBoardTemplate] = useState("");
  const [creatingBoard, setCreatingBoard] = useState(false);
  const newBoardBtnRef = useRef(null);
  const isAdmin = user.profile === "admin";

  const fetchBoards = useCallback(async () => {
    try {
      const { data } = await api.get("/kanban-boards");
      setBoards(Array.isArray(data) ? data : []);
      return data;
    } catch (e) { console.log(e); return []; }
  }, []);

  useEffect(() => { fetchBoards(); }, [fetchBoards]);

  useEffect(() => {
    if (!boards.length) return;
    if (!activeBoardId || !boards.some((b) => b.id === activeBoardId)) {
      const defaultBoard = boards.find((b) => b.isDefault) || boards[0];
      setActiveBoardId(defaultBoard.id);
    }
  }, [boards, activeBoardId]);

  useEffect(() => {
    if (activeBoardId) {
      try { localStorage.setItem(`kanban-active-board-${user.companyId}`, String(activeBoardId)); } catch {}
    }
  }, [activeBoardId, user.companyId]);

  const handleCreateBoard = async () => {
    const name = (newBoardName || "").trim();
    if (!name) return;
    setCreatingBoard(true);
    try {
      const payload = { name };
      if (newBoardTemplate) payload.template = newBoardTemplate;
      const { data } = await api.post("/kanban-boards", payload);
      await fetchBoards();
      if (data?.id) setActiveBoardId(data.id);
      setNewBoardPopover({ open: false, anchorEl: null });
      setNewBoardName("");
      setNewBoardTemplate("");
    } catch (err) { console.log(err); }
    finally { setCreatingBoard(false); }
  };
  const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filterResetKey, setFilterResetKey] = useState(0);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [showAllKanban, setShowAllKanban] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [unrepliedOnly, setUnrepliedOnly] = useState(false);
  const [sortAsc, setSortAsc] = useState(false);
  const [quickStatus, setQuickStatus] = useState("all");
  const kanbanRootRef = useRef(null);

  useEffect(() => {
    const onFsChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onFsChange);
    return () => document.removeEventListener("fullscreenchange", onFsChange);
  }, []);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (kanbanRootRef.current?.requestFullscreen) {
      kanbanRootRef.current.requestFullscreen();
    }
  };

  // drag state
  const dragItem = useRef(null);
  const dropSuccessRef = useRef(false);
  const [dragState, setDragState] = useState(null); // { ticketId, sourceLaneId, targetLaneId, targetIndex }

  // contact drawer
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const queueIds = user.queues.map((q) => q.UserQueue.queueId);

  /* ─── fetch ─── */
  const fetchTags = useCallback(async () => {
    try {
      const params = activeBoardId ? { boardId: activeBoardId } : {};
      const { data } = await api.get("/tag/kanban/", { params });
      setTags(data.lista || []);
    } catch (e) { console.log(e); }
  }, [activeBoardId]);

  const fetchTickets = useCallback(async () => {
    try {
      const { data } = await api.get("/ticket/kanban", {
        params: {
          queueIds: JSON.stringify(queueIds),
          startDate,
          endDate,
          showAll: showAllKanban ? "true" : "false",
        },
      });
      setTickets(data.tickets);
    } catch (e) { console.log(e); setTickets([]); }
  }, [JSON.stringify(queueIds), startDate, endDate, showAllKanban]);

  useEffect(() => { fetchTags(); }, [fetchTags]);
  useEffect(() => { fetchTickets(); }, [fetchTickets]);

  // refetch after tags load
  useEffect(() => { if (tags.length) fetchTickets(); }, [tags]);

  // socket
  useEffect(() => {
    const cid = user.companyId;
    let debounceTimer;
    const handler = (d) => {
      if (["create", "update", "delete"].includes(d.action)) {
        if (d.message && d.ticket?.id) {
          setTickets((prev) => prev.map((t) => (
            t.id === d.ticket.id
              ? {
                  ...t,
                  lastMessage: d.ticket.lastMessage ?? t.lastMessage,
                  messages: [{ id: d.message.id, body: d.message.body, mediaType: d.message.mediaType, mediaUrl: d.message.mediaUrl }],
                }
              : t
          )));
        }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(fetchTickets, 500);
      }
    };
    const tagHandler = (d) => {
      if (["create", "update", "delete"].includes(d?.action)) fetchTags();
    };
    const contactHandler = (d) => {
      if (d?.action === "update" && d?.contact) {
        setTickets((prev) => prev.map((t) => (
          t.contactId === d.contact.id || t.contact?.id === d.contact.id
            ? { ...t, contact: { ...(t.contact || {}), ...d.contact } }
            : t
        )));
      } else if (["create", "delete"].includes(d?.action)) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(fetchTickets, 500);
      }
    };
    socket.on(`company-${cid}-ticket`, handler);
    socket.on(`company-${cid}-appMessage`, handler);
    socket.on(`company${cid}-tag`, tagHandler);
    socket.on(`company-${cid}-tag`, tagHandler);
    socket.on(`company-${cid}-contact`, contactHandler);
    return () => {
      socket.off(`company-${cid}-ticket`, handler);
      socket.off(`company-${cid}-appMessage`, handler);
      socket.off(`company${cid}-tag`, tagHandler);
      socket.off(`company-${cid}-tag`, tagHandler);
      socket.off(`company-${cid}-contact`, contactHandler);
    };
  }, [socket, fetchTickets, fetchTags]);

  /* ─── lanes data ─── */
  const { ticketSearchParam, searchOnMessages } = useSearch();
  const lanes = React.useMemo(() => {
    const q = (ticketSearchParam || "").trim().toLowerCase();
    const matchesSearch = (t) => {
      if (!q) return true;
      if (searchOnMessages) {
        return String(t.lastMessage || "").toLowerCase().includes(q);
      }
      const name = String(t.contact?.name || "").toLowerCase();
      const num = String(t.contact?.number || "").toLowerCase();
      return name.includes(q) || num.includes(q);
    };
    const queueIdsFilter = selectedQueueIds || [];
    const tagIdsFilter = (selectedTags || []).map((t) => (typeof t === "object" ? t.id : t));
    const userIdsFilter = (selectedUsers || []).map((u) => (typeof u === "object" ? u.id : u));
    const whatsappIdsFilter = (selectedWhatsapp || []).map((w) => (typeof w === "object" ? w.id : w));
    const statusFilter = (selectedStatus || []).map((s) => (typeof s === "object" ? (s.status || s.value || s.id) : s));

    const currentUserId = user?.id;
    const canSeeAll = user?.profile === "admin" || user?.allUserChat === "enabled";
    const matchesFilters = (t) => {
      if (!showAllKanban && canSeeAll && currentUserId) {
        if (t.userId && t.userId !== currentUserId && t.status !== "pending") return false;
      }
      if (quickStatus !== "all") {
        const isGroup = t.isGroup || t.status === "group";
        if (quickStatus === "group" && !isGroup) return false;
        if (quickStatus === "open" && (isGroup || t.status !== "open")) return false;
        if (quickStatus === "pending" && (isGroup || t.status !== "pending")) return false;
      }
      if (unrepliedOnly && !(Number(t.unreadMessages) > 0)) return false;
      if (queueIdsFilter.length > 0 && !queueIdsFilter.includes(t.queueId)) return false;
      if (tagIdsFilter.length > 0) {
        const has = (t.contact?.tags || []).some((tt) => tagIdsFilter.includes(tt.id));
        if (!has) return false;
      }
      if (userIdsFilter.length > 0 && !userIdsFilter.includes(t.userId)) return false;
      if (whatsappIdsFilter.length > 0 && !whatsappIdsFilter.includes(t.whatsappId)) return false;
      if (statusFilter.length > 0 && !statusFilter.includes(t.status)) return false;
      return true;
    };

    const filteredTickets = tickets.filter((t) => matchesSearch(t) && matchesFilters(t)).slice().sort((a, b) => {
      const ad = new Date(a.updatedAt || a.createdAt).getTime();
      const bd = new Date(b.updatedAt || b.createdAt).getTime();
      return sortAsc ? ad - bd : bd - ad;
    });
    const noTag = filteredTickets.filter((t) => !t.tags || t.tags.length === 0);
    const sumVal = (arr) => arr.reduce((s, t) => {
      const prodTotal = (t.contact?.products || []).reduce((ps, p) => ps + (Number(p.value) || 0), 0);
      return s + (prodTotal || (Number(t.value) || 0));
    }, 0);

    const defaultLane = {
      id: "lane0",
      name: i18n.t("tagsKanban.laneDefault"),
      color: theme.palette.primary?.main || "#1976d2",
      tickets: noTag,
      total: sumVal(noTag),
    };

    const tagLanes = tags.map((tag) => {
      const tagTickets = filteredTickets.filter((t) => t.tags?.some((tt) => tt.id === tag.id));
      return {
        id: tag.id.toString(),
        name: tag.name,
        color: tag.color || "#1976d2",
        dealOutcome: tag.dealOutcome || null,
        isSystemDefault: !!tag.isSystemDefault,
        isLocked: !!tag.isLocked,
        lockReasons: Array.isArray(tag.lockReasons) ? tag.lockReasons : [],
        lockedBy: tag.lockedBy || [],
        tickets: tagTickets,
        total: sumVal(tagTickets),
      };
    });

    return [defaultLane, ...tagLanes];
  }, [tickets, tags, theme, boards, activeBoardId, ticketSearchParam, searchOnMessages, selectedQueueIds, selectedTags, selectedUsers, selectedWhatsapp, selectedStatus, showAllKanban, user, unrepliedOnly, sortAsc, quickStatus]);

  /* ─── drag & drop ─── */
  const boardRef = useRef(null);

  /* ─── scroll nav arrows ─── */
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const scrollNavInterval = useRef(null);

  const updateScrollArrows = useCallback(() => {
    const el = boardRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 2);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
  }, []);

  const stopScrollNav = () => {
    if (scrollNavInterval.current) {
      clearInterval(scrollNavInterval.current);
      scrollNavInterval.current = null;
    }
  };
  const startScrollNav = (dir) => {
    stopScrollNav();
    scrollNavInterval.current = setInterval(() => {
      const el = boardRef.current;
      if (!el) return;
      el.scrollLeft += dir === "right" ? 8 : -8;
      updateScrollArrows();
    }, 16);
  };

  useEffect(() => {
    const el = boardRef.current;
    if (!el) return;
    const handler = () => updateScrollArrows();
    el.addEventListener("scroll", handler, { passive: true });
    const ro = new ResizeObserver(handler);
    ro.observe(el);
    updateScrollArrows();
    return () => { el.removeEventListener("scroll", handler); ro.disconnect(); stopScrollNav(); };
  }, [updateScrollArrows, lanes]);

  const scrollInterval = useRef(null);
  const mouseXRef = useRef(0);
  const dragThrottle = useRef(null);

  // Auto-scroll: um único setInterval que roda enquanto arrasta
  const startAutoScroll = () => {
    if (scrollInterval.current) return;
    scrollInterval.current = setInterval(() => {
      const board = boardRef.current;
      if (!board || !dragItem.current) return;
      const rect = board.getBoundingClientRect();
      const mx = mouseXRef.current;
      const edge = 150;
      if (mx < rect.left + edge) {
        const pct = 1 - Math.max(0, mx - rect.left) / edge;
        board.scrollLeft -= Math.round(12 + 35 * pct);
      } else if (mx > rect.right - edge) {
        const pct = 1 - Math.max(0, rect.right - mx) / edge;
        board.scrollLeft += Math.round(12 + 35 * pct);
      }
    }, 16);
  };

  const stopAutoScroll = () => {
    clearInterval(scrollInterval.current);
    scrollInterval.current = null;
  };

  const onDragStart = (e, ticketId, laneId) => {
    dragItem.current = { ticketId, sourceLaneId: laneId };
    dropSuccessRef.current = false;
    e.dataTransfer.effectAllowed = "move";
    mouseXRef.current = e.clientX;
    startAutoScroll();
    setTimeout(() => setDragState({ ticketId, sourceLaneId: laneId, targetLaneId: laneId, targetIndex: -1 }), 0);
  };

  const onLaneDragOver = (e, laneId) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    mouseXRef.current = e.clientX;
    if (!dragItem.current) return;

    // Throttle: só atualiza state a cada 150ms
    if (dragThrottle.current) return;
    dragThrottle.current = setTimeout(() => { dragThrottle.current = null; }, 150);

    const laneCardsEl = e.currentTarget.querySelector("[data-lane-cards]");
    let targetIndex = -1;
    if (laneCardsEl) {
      const cards = laneCardsEl.querySelectorAll("[data-card-id]");
      const mouseY = e.clientY;
      for (let i = 0; i < cards.length; i++) {
        const r = cards[i].getBoundingClientRect();
        if (mouseY < r.top + r.height / 2) { targetIndex = i; break; }
      }
    }

    setDragState((prev) => {
      if (prev && prev.targetLaneId === laneId && prev.targetIndex === targetIndex) return prev;
      return { ...prev, targetLaneId: laneId, targetIndex };
    });
  };

  const onDrop = async (e, targetLaneId) => {
    e.preventDefault();
    stopAutoScroll();
    if (!dragItem.current) return;
    const { ticketId, sourceLaneId } = dragItem.current;
    dropSuccessRef.current = true;
    dragItem.current = null;
    setDragState(null);
    handleCardMove(ticketId, sourceLaneId, targetLaneId);
  };

  const onDragEnd = () => {
    const wasDropped = dropSuccessRef.current;
    dragItem.current = null;
    setDragState(null);
    stopAutoScroll();
    if (!wasDropped) {
      fetchTickets();
    }
    dropSuccessRef.current = false;
  };

  /* ─── card actions ─── */
  const handleCardMove = async (ticketId, sourceLaneId, targetLaneId) => {
    if (sourceLaneId === targetLaneId) return;

    // Optimistic update — move localmente antes da API
    setTickets((prev) => prev.map((t) => {
      if (t.id !== ticketId) return t;
      const newTags = targetLaneId === "lane0"
        ? []
        : [{ id: Number(targetLaneId), name: "", color: "" }];
      return { ...t, tags: newTags };
    }));

    try {
      await api.delete(`/ticket-tags/${ticketId}`);
      if (targetLaneId !== "lane0") {
        await api.put(`/ticket-tags/${ticketId}/${targetLaneId}`);
      }
      fetchTickets();
    } catch (err) {
      console.log(err);
      fetchTickets(); // rollback
    }
  };

  const [deleteTicketModal, setDeleteTicketModal] = useState({ open: false, ticketId: null, contactId: null, name: "", alsoDeleteContact: false });

  const handleDeleteTicket = (ticketId) => {
    const t = tickets.find((x) => x.id === ticketId);
    setDeleteTicketModal({
      open: true,
      ticketId,
      contactId: t?.contact?.id || null,
      name: t?.contact?.name || "",
      alsoDeleteContact: false,
    });
  };

  const handleDeleteTicketConfirm = async () => {
    const { ticketId, contactId, alsoDeleteContact } = deleteTicketModal;
    setDeleteTicketModal({ open: false, ticketId: null, contactId: null, name: "", alsoDeleteContact: false });
    if (!ticketId) return;
    try {
      await api.delete(`/tickets/${ticketId}`);
      if (alsoDeleteContact && contactId) {
        try { await api.delete(`/contacts/${contactId}`); } catch (e) { console.log(e); }
      }
      fetchTickets();
    } catch (err) { console.log(err); }
  };

  const handleToggleMute = async (ticketId) => {
    try {
      const ticket = tickets.find((t) => t.id === ticketId);
      const isMuted = !!ticket?.mutedUntil;
      await api.patch(`/tickets/${ticketId}/mute`, { muted: !isMuted });
      fetchTickets();
    } catch (err) { console.log(err); }
  };

  const handleCloseTicket = async (ticketId) => {
    try {
      await api.put(`/tickets/${ticketId}`, { status: "closed", userId: user?.id || null });

      fetchTickets();
    } catch (err) { console.log(err); }
  };

  // transfer modal
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [transferTicketId, setTransferTicketId] = useState(null);

  /* ─── column management ─── */
  const [addColPopover, setAddColPopover] = useState({ open: false, anchorEl: null, position: null, refLaneId: null, editingLaneId: null, initialName: "", initialColor: "#1976d2" });
  const [addColSaving, setAddColSaving] = useState(false);
  const [deleteBoardConfirm, setDeleteBoardConfirm] = useState({ open: false, board: null });

  const handleRequestDeleteBoard = async (board) => {
    try {
      const { data } = await api.get("/tag/kanban/", { params: { boardId: board.id } });
      const boardTags = data?.lista || [];
      const tagIds = boardTags.map((t) => t.id);
      const hasCards = tickets.some((t) =>
        t.tags?.some((tt) => tagIds.includes(tt.id))
      );
      if (hasCards) {
        toast.info(i18n.t("kanban.toasts.transferCardsBeforeDelete"));
        return;
      }
      setDeleteBoardConfirm({ open: true, board });
    } catch (err) {
      toastError(err);
    }
  };

  const handleConfirmDeleteBoard = async () => {
    const board = deleteBoardConfirm.board;
    if (!board) return;
    try {
      await api.delete(`/kanban-boards/${board.id}`);
      setDeleteBoardConfirm({ open: false, board: null });
      if (activeBoardId === board.id) setActiveBoardId(null);
      await fetchBoards();
      toast.success(i18n.t("kanban.toasts.boardDeleted"));
    } catch (err) {
      toastError(err);
    }
  };

  const handleAddColumn = (position, refLaneId, anchorEl) => {
    setAddColPopover({
      open: true,
      anchorEl,
      position,
      refLaneId,
      editingLaneId: null,
      initialName: "",
      initialColor: "#1976d2",
    });
  };

  const handleAddColumnClose = () => {
    if (addColSaving) return;
    setAddColPopover({ open: false, anchorEl: null, position: null, refLaneId: null, editingLaneId: null, initialName: "", initialColor: "#1976d2" });
  };

  const [newCardModal, setNewCardModal] = useState({ open: false, laneId: null });
  const [editContactModal, setEditContactModal] = useState({ open: false, contactId: null, ticketId: null, laneId: null, originalLaneId: null, userId: "", originalUserId: "" });
  const [moveBoardPopover, setMoveBoardPopover] = useState({ open: false, anchorPosition: null, ticketId: null, boardId: "", laneId: "", lanes: [], loading: false });

  const handleMoveBoardBoardChange = async (newBoardId) => {
    setMoveBoardPopover((prev) => ({ ...prev, boardId: newBoardId, laneId: "", lanes: [], loading: true }));
    try {
      const { data } = await api.get("/tag/kanban/", { params: { boardId: newBoardId } });
      const lanes = (data?.lista || []);
      setMoveBoardPopover((prev) => ({ ...prev, lanes, loading: false }));
    } catch (e) {
      console.log(e);
      setMoveBoardPopover((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleMoveBoardConfirm = async () => {
    const { ticketId, laneId } = moveBoardPopover;
    if (!ticketId || !laneId) return;
    try {
      await api.delete(`/ticket-tags/${ticketId}`);
      await api.put(`/ticket-tags/${ticketId}/${laneId}`);
      setMoveBoardPopover({ open: false, anchorPosition: null, ticketId: null, boardId: "", laneId: "", lanes: [], loading: false });
      fetchTickets();
    } catch (e) { console.log(e); }
  };
  const [usersList, setUsersList] = useState([]);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/users/list"); setUsersList(Array.isArray(data) ? data : (data?.users || [])); } catch {}
    })();
  }, []);

  const openNewCard = (lane) => {
    setNewCardModal({ open: true, laneId: lane.id });
  };

  const handleNewCardContactSaved = async (contact) => {
    if (!contact?.id) return;
    const targetLaneId = newCardModal.laneId || "lane0";

    let ticketId = null;
    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: contact.id,
        status: "open",
        userId: user.id,
        whatsappId: "",
      });
      ticketId = ticket?.id;
    } catch (err) {
      const apiErr = err?.response?.data?.error || err?.response?.data?.message || "";
      // Lead já tem ticket aberto/pending — reaproveita pra só atribuir a lane.
      if (apiErr === "ERR_OTHER_OPEN_TICKET") {
        try {
          const { data: full } = await api.get(`/contacts/${contact.id}`);
          const openTicket = (full?.tickets || []).find(
            (t) => t.status === "open" || t.status === "pending"
          ) || (full?.tickets || [])[0];
          if (openTicket) ticketId = openTicket.id;
        } catch (e) { console.log(e); }
      } else {
        try {
          const { toast } = await import("react-toastify");
          toast.error(apiErr || "Não foi possível criar o card");
        } catch {}
        return;
      }
    }

    if (ticketId && targetLaneId !== "lane0") {
      try { await api.put(`/ticket-tags/${ticketId}/${targetLaneId}`); } catch (e) { console.log(e); }
    }
    fetchTickets();
  };

  const handleAddColumnSave = async ({ name, color }) => {
    setAddColSaving(true);
    try {
      if (addColPopover.editingLaneId) {
        // edit existente — PUT /tags/:id
        await api.put(`/tags/${addColPopover.editingLaneId}`, {
          name,
          color,
          kanban: 1,
        });
      } else {
        await api.post("/tags", {
          name,
          color,
          kanban: 1,
          placement: addColPopover.position,
          refLaneId: addColPopover.refLaneId,
          boardId: activeBoardId,
        });
      }
      await fetchTags();
      setAddColPopover({ open: false, anchorEl: null, position: null, refLaneId: null, editingLaneId: null, initialName: "", initialColor: "#1976d2" });
    } catch (err) {
      console.log(err);
      const apiMsg = err?.response?.data?.error;
      if (apiMsg) {
        try { (await import("react-toastify")).toast.error(apiMsg); } catch {}
      }
    }
    finally { setAddColSaving(false); }
  };

  const handleEditColumnRequest = (lane, anchorEl) => {
    if (lane.id === "lane0") return;
    setAddColPopover({
      open: true,
      anchorEl: anchorEl || null,
      position: null,
      refLaneId: null,
      editingLaneId: lane.id,
      initialName: lane.name || "",
      initialColor: lane.color || "#1976d2",
      isSystemDefault: !!lane.isSystemDefault,
    });
  };

  const handleRenameColumn = async (tagId, newName) => {
    const trimmed = (newName || "").trim();
    if (!trimmed) return;
    try {
      await api.put(`/tags/${tagId}`, { name: trimmed });
      fetchTags();
    } catch (err) { console.log(err); }
  };

  const [deleteColModal, setDeleteColModal] = useState({ open: false, laneId: null, laneName: "", ticketCount: 0 });
  const [deleteTransferTo, setDeleteTransferTo] = useState("");

  const handleDeleteColumnRequest = (lane) => {
    if (lane.id === "lane0") return;
    setDeleteColModal({ open: true, laneId: lane.id, laneName: lane.name, ticketCount: lane.tickets.length });
    setDeleteTransferTo("");
  };

  const handleDeleteColumnConfirm = async (laneId, transferToId) => {
    try {
      if (transferToId) {
        const laneTickets = tickets.filter((t) => t.tags?.some((tt) => tt.id.toString() === laneId));
        for (const t of laneTickets) {
          await api.delete(`/ticket-tags/${t.id}`);
          if (transferToId !== "lane0") await api.put(`/ticket-tags/${t.id}/${transferToId}`);
        }
      }
      await api.delete(`/tags/${laneId}`);

      setDeleteColModal({ open: false, laneId: null, laneName: "", ticketCount: 0 });
      fetchTags();
      fetchTickets();
    } catch (err) { console.log(err);}
  };

  const openTicketDrawer = (ticket) => {
    setSelectedTicket(ticket);
    setDrawerOpen(true);
  };

  const goToTicket = (uuid) => history.push("/tickets/" + uuid);

  /* ─── filters ─── */
  const today = format(new Date(), "yyyy-MM-dd");
  const dateFilterActive =
    ((startDate !== today || endDate !== today) ? 1 : 0)
    + (selectedQueueIds.length > 0 ? 1 : 0)
    + (selectedTags.length > 0 ? 1 : 0)
    + (selectedWhatsapp.length > 0 ? 1 : 0)
    + (selectedStatus.length > 0 ? 1 : 0)
    + (selectedUsers.length > 0 ? 1 : 0);
  const handleClearFilters = () => {
    const t = format(new Date(), "yyyy-MM-dd");
    setStartDate(t);
    setEndDate(t);
    setSelectedQueueIds([]);
    setSelectedTags([]);
    setSelectedWhatsapp([]);
    setSelectedStatus([]);
    setSelectedUsers([]);
    setFilterResetKey((k) => k + 1);
  };

  /* ─── render ─── */
  return (
    <div className={classes.root} ref={kanbanRootRef} style={isFullscreen ? { background: "#111", height: "100vh", overflow: "auto" } : undefined}>
      {/* toolbar (padrão global) */}
      <MainHeader>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <div className={classes.leftHeaderGroup}>
          <button
            type="button"
            className={classes.filterTriggerBtn}
            onClick={() => setFilterDrawerOpen(true)}
            title={i18n.t("kanban.filters.title")}
          >
            <FilterIcon size={16} strokeWidth={1.8} />
            <span>{i18n.t("kanban.filters.title")}</span>
            {dateFilterActive > 0 && (
              <span className={classes.filterCountBadge}>{dateFilterActive}</span>
            )}
          </button>
        </div>
        <Drawer
          anchor="left"
          open={filterDrawerOpen}
          onClose={() => setFilterDrawerOpen(false)}
          classes={{ paper: classes.filterDrawerPaper }}
        >
          <div className={classes.filterDrawerHeader}>
            <Typography className={classes.filterDrawerTitle}>
              {i18n.t("kanban.filters.title")}
            </Typography>
            <IconButton
              size="small"
              aria-label="close-filter"
              className={classes.filterDrawerClose}
              onClick={() => setFilterDrawerOpen(false)}
            >
              <LuX size={18} />
            </IconButton>
          </div>
          <div className={classes.filterDrawerContent}>
            <Typography className={classes.filterSectionLabel}>{i18n.t("kanban.startDate")}</Typography>
            <div style={{ padding: "0 12px 8px" }}>
              <DatePickerCustom value={startDate} onChange={(v) => setStartDate(v)} />
            </div>
            <Typography className={classes.filterSectionLabel}>{i18n.t("kanban.endDate")}</Typography>
            <div style={{ padding: "0 12px 8px" }}>
              <DatePickerCustom value={endDate} onChange={(v) => setEndDate(v)} />
            </div>
            <Typography className={classes.filterSectionLabel}>{i18n.t("kanban.filters.queues")}</Typography>
            <div style={{ padding: "0 12px 8px" }}>
              <TicketsQueueSelect
                key={`queue-${filterResetKey}`}
                selectedQueueIds={selectedQueueIds}
                userQueues={user?.queues}
                onChange={(values) => setSelectedQueueIds(values)}
              />
            </div>
            <Typography className={classes.filterSectionLabel}>{i18n.t("kanban.filters.tags")}</Typography>
            <div style={{ padding: "0 12px 8px" }}>
              <TagsFilter key={`tags-${filterResetKey}`} onFiltered={setSelectedTags} />
            </div>
            <Typography className={classes.filterSectionLabel}>{i18n.t("kanban.filters.connections")}</Typography>
            <div style={{ padding: "0 12px 8px" }}>
              <WhatsappsFilter key={`wpp-${filterResetKey}`} onFiltered={setSelectedWhatsapp} />
            </div>
            <Typography className={classes.filterSectionLabel}>{i18n.t("kanban.filters.status")}</Typography>
            <div style={{ padding: "0 12px 8px" }}>
              <StatusFilter key={`status-${filterResetKey}`} onFiltered={setSelectedStatus} />
            </div>
            {user?.profile === "admin" && (
              <>
                <Typography className={classes.filterSectionLabel}>{i18n.t("kanban.filters.attendants")}</Typography>
                <div style={{ padding: "0 12px 8px" }}>
                  <UsersFilter key={`users-${filterResetKey}`} onFiltered={setSelectedUsers} />
                </div>
              </>
            )}
          </div>
          <div className={classes.filterDrawerFooter}>
            <Button
              size="small"
              onClick={handleClearFilters}
              disabled={dateFilterActive === 0}
            >
              {i18n.t("kanban.filters.clearAll") || "Limpar filtros"}
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => setFilterDrawerOpen(false)}
              style={{ borderRadius: 12 }}
            >
              {i18n.t("kanban.filters.apply") || "Aplicar"}
            </Button>
          </div>
        </Drawer>
        </div>
        <MainHeaderButtonsWrapper>
        <div className={classes.boardsBar}>
          {(user?.profile === "admin" || user?.allUserChat === "enabled") && (
            <AppTooltip title={showAllKanban ? i18n.t("kanban.tooltips.viewOnlyMine") : i18n.t("kanban.tooltips.viewAll")}>
              <span
                style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 8, color: showAllKanban ? theme.palette.primary.main : (theme.mode === "light" ? "#1a1a1a" : "#e9edef"), transition: "color 0.2s, background 0.2s" }}
                onClick={() => setShowAllKanban((p) => !p)}
              >
                {showAllKanban ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6.5 6.15642C7.16531 5.38547 7.58503 5 8.10017 5C8.73332 5 9.22232 5.58231 10.2003 6.74694L12.4677 9.44699C13.4892 10.6634 14 11.2716 14 12C14 12.7284 13.4892 13.3366 12.4677 14.553L10.2003 17.2531C9.22232 18.4177 8.73332 19 8.10017 19C7.58503 19 7.16531 18.6145 6.5 17.8436" />
                    <path d="M2 12H8" />
                    <path d="M13 19L16.5118 14.6032C17.5039 13.361 18 12.7398 18 12C18 11.2602 17.5039 10.639 16.5118 9.39683L13 5" />
                    <path d="M17 19L20.5118 14.6032C21.5039 13.361 22 12.7398 22 12C22 11.2602 21.5039 10.639 20.5118 9.39683L17 5" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6.5 6.15642C7.16531 5.38547 7.58503 5 8.10017 5C8.73332 5 9.22232 5.58231 10.2003 6.74694L12.4677 9.44699C13.4892 10.6634 14 11.2716 14 12C14 12.7284 13.4892 13.3366 12.4677 14.553L10.2003 17.2531C9.22232 18.4177 8.73332 19 8.10017 19C7.58503 19 7.16531 18.6145 6.5 17.8436" />
                    <path d="M5 15L5 9M2 12H8" />
                    <path d="M13 19L16.5118 14.6032C17.5039 13.361 18 12.7398 18 12C18 11.2602 17.5039 10.639 16.5118 9.39683L13 5" />
                    <path d="M17 19L20.5118 14.6032C21.5039 13.361 22 12.7398 22 12C22 11.2602 21.5039 10.639 20.5118 9.39683L17 5" />
                  </svg>
                )}
              </span>
            </AppTooltip>
          )}
          {(() => {
            const QuickIcon = ({ active, onClick, title, children, color }) => (
              <AppTooltip title={title}>
                <span
                  style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 8, color: active ? (color || theme.palette.primary.main) : (theme.mode === "light" ? "#1a1a1a" : "#e9edef"), transition: "color 0.2s" }}
                  onClick={onClick}
                >
                  {children}
                </span>
              </AppTooltip>
            );
            return (
              <>
                {(() => {
                  const opts = [
                    { key: "all", title: i18n.t("kanban.filters.tabs.all"), icon: (
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M6.00449 6.5V6M7.00449 6.5C7.00449 5.94772 6.55677 5.5 6.00449 5.5C5.4522 5.5 5.00449 5.94772 5.00449 6.5C5.00449 7.05228 5.4522 7.5 6.00449 7.5C6.55677 7.5 7.00449 7.05228 7.00449 6.5Z" />
                        <path d="M6.00449 12.5V12M7.00449 12.5C7.00449 11.9477 6.55677 11.5 6.00449 11.5C5.4522 11.5 5.00449 11.9477 5.00449 12.5C5.00449 13.0523 5.4522 13.5 6.00449 13.5C6.55677 13.5 7.00449 13.0523 7.00449 12.5Z" />
                        <path d="M6.00449 18.5V18M7.00449 18.5C7.00449 17.9477 6.55677 17.5 6.00449 17.5C5.4522 17.5 5.00449 17.9477 5.00449 18.5C5.00449 19.0523 5.4522 19.5 6.00449 19.5C6.55677 19.5 7.00449 19.0523 7.00449 18.5Z" />
                        <path d="M18.0045 6.5V6M19.0045 6.5C19.0045 5.94772 18.5568 5.5 18.0045 5.5C17.4522 5.5 17.0045 5.94772 17.0045 6.5C17.0045 7.05228 17.4522 7.5 18.0045 7.5C18.5568 7.5 19.0045 7.05228 19.0045 6.5Z" />
                        <path d="M18.0045 12.5V12M19.0045 12.5C19.0045 11.9477 18.5568 11.5 18.0045 11.5C17.4522 11.5 17.0045 11.9477 17.0045 12.5C17.0045 13.0523 17.4522 13.5 18.0045 13.5C18.5568 13.5 19.0045 13.0523 19.0045 12.5Z" />
                        <path d="M12.0045 12.5V12M13.0045 12.5C13.0045 11.9477 12.5568 11.5 12.0045 11.5C11.4522 11.5 11.0045 11.9477 11.0045 12.5C11.0045 13.0523 11.4522 13.5 12.0045 13.5C12.5568 13.5 13.0045 13.0523 13.0045 12.5Z" />
                        <path d="M12.0045 6.5V6M13.0045 6.5C13.0045 5.94772 12.5568 5.5 12.0045 5.5C11.4522 5.5 11.0045 5.94772 11.0045 6.5C11.0045 7.05228 11.4522 7.5 12.0045 7.5C12.5568 7.5 13.0045 7.05228 13.0045 6.5Z" />
                        <path d="M18.0045 18.5V18M19.0045 18.5C19.0045 17.9477 18.5568 17.5 18.0045 17.5C17.4522 17.5 17.0045 17.9477 17.0045 18.5C17.0045 19.0523 17.4522 19.5 18.0045 19.5C18.5568 19.5 19.0045 19.0523 19.0045 18.5Z" />
                        <path d="M12.0045 18.5V18M13.0045 18.5C13.0045 17.9477 12.5568 17.5 12.0045 17.5C11.4522 17.5 11.0045 17.9477 11.0045 18.5C11.0045 19.0523 11.4522 19.5 12.0045 19.5C12.5568 19.5 13.0045 19.0523 13.0045 18.5Z" />
                      </svg>
                    ) },
                    { key: "open", title: i18n.t("kanban.filters.tabs.open"), icon: <MessageCircleCheck size={16} strokeWidth={1.5} /> },
                    { key: "pending", title: i18n.t("kanban.filters.tabs.pending"), icon: <MessageCircleMore size={16} strokeWidth={1.5} /> },
                    { key: "group", title: i18n.t("kanban.filters.tabs.group"), icon: <UsersRound size={16} strokeWidth={1.5} /> },
                  ];
                  const idx = Math.max(0, opts.findIndex((o) => o.key === quickStatus));
                  const itemW = 36;
                  return (
                    <div style={{
                      position: "relative",
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "2px 2px",
                      borderRadius: 14,
                      gap: 2,
                      background: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.06)",
                    }}>
                      <div style={{
                        position: "absolute",
                        top: 3,
                        bottom: 3,
                        left: `calc(2px + ${idx * (itemW + 2)}px)`,
                        width: itemW,
                        borderRadius: 100,
                        background: theme.mode === "light" ? "rgba(255,255,255,0.10)" : "rgba(255,255,255,0.14)",
                        backdropFilter: "blur(8px)",
                        WebkitBackdropFilter: "blur(8px)",
                        border: "none",
                        boxShadow: theme.mode === "light" ? "0 1px 3px rgba(0,0,0,0.06)" : "0 1px 3px rgba(0,0,0,0.2)",
                        transition: "left 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                        zIndex: 0,
                      }} />
                      {opts.map((opt) => {
                        return (
                          <AppTooltip key={opt.key} title={opt.title}>
                            <span
                              onClick={() => setQuickStatus(opt.key)}
                              style={{
                                position: "relative",
                                zIndex: 1,
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: itemW,
                                height: 25,
                                color: theme.mode === "light" ? "#1a1a1a" : "#e9edef",
                              }}
                            >
                              {opt.icon}
                            </span>
                          </AppTooltip>
                        );
                      })}
                    </div>
                  );
                })()}
                <QuickIcon
                  active={unrepliedOnly}
                  onClick={() => setUnrepliedOnly((p) => !p)}
                  title={i18n.t("kanban.filters.unreplied")}
                  color="#ff9800"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                    <path d="M12 8v4" />
                    <path d="M12 16h.01" />
                  </svg>
                </QuickIcon>
                <QuickIcon
                  active={sortAsc}
                  onClick={() => setSortAsc((p) => !p)}
                  title={sortAsc ? i18n.t("kanban.tooltips.sortDesc") : i18n.t("kanban.tooltips.sortAsc")}
                >
                  {sortAsc ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M11 12H21" /><path d="M11 16H18" /><path d="M11 20H15" />
                      <path d="M3 7.99997C3 7.99997 5.94596 4.00001 7.00003 4C8.05411 3.99999 11 8 11 8" />
                      <path d="M7 5V20" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M11 20H21" /><path d="M11 16H18" /><path d="M11 12H15" />
                      <path d="M3 7.99997C3 7.99997 5.94596 4.00001 7.00003 4C8.05411 3.99999 11 8 11 8" />
                      <path d="M7 5V20" />
                    </svg>
                  )}
                </QuickIcon>
              </>
            );
          })()}
          <AppTooltip title={isFullscreen ? i18n.t("kanban.tooltips.exitFullscreen") : i18n.t("kanban.tooltips.enterFullscreen")}>
            <span
              style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 8, color: theme.mode === "light" ? "#1a1a1a" : "#e9edef", transition: "color 0.2s" }}
              onClick={toggleFullscreen}
            >
              {isFullscreen ? (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 4v4H5M15 4v4h4M9 20v-4H5M15 20v-4h4" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 9V5h4M20 9V5h-4M4 15v4h4M20 15v4h-4" />
                </svg>
              )}
            </span>
          </AppTooltip>
        </div>
          {/* Botão de novo board removido — sistema usa apenas o board padrão */}
          <button
            type="button"
            className={actionBtnClasses.actionBtn}
            onClick={() => {
              const first = lanes.find((l) => l.id !== "lane0") || lanes[0];
              setNewCardModal({ open: true, laneId: first?.id || "lane0" });
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"></path></svg>
            {i18n.t("kanban.addCard")}
          </button>
        </MainHeaderButtonsWrapper>
      </MainHeader>

      {/* board */}
      <div className={classes.boardWrapper}>
        {/* scroll nav: left */}
        {canScrollLeft && (
          <button
            className={`${classes.scrollArrow} ${classes.scrollArrowLeft} ${classes.scrollArrowVisible}`}
            onMouseEnter={() => startScrollNav("left")}
            onMouseLeave={stopScrollNav}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
          </button>
        )}

        {/* scroll nav: right */}
        {canScrollRight && (
          <button
            className={`${classes.scrollArrow} ${classes.scrollArrowRight} ${classes.scrollArrowVisible}`}
            onMouseEnter={() => startScrollNav("right")}
            onMouseLeave={stopScrollNav}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
          </button>
        )}

        <div className={classes.board} ref={boardRef} onDragOver={(e) => {
          e.preventDefault();
          mouseXRef.current = e.clientX;
        }}
        onDrop={(e) => {
          e.preventDefault();
          stopAutoScroll();
          if (dragItem.current) {
            dropSuccessRef.current = true;
            dragItem.current = null;
            setDragState(null);
          }
        }}>
          {lanes.length === 0 && (
            <div style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 12,
              padding: 24,
              color: "#1a1a1a",
              opacity: 0.9,
            }}>
              <KanbanIcon size={48} strokeWidth={1.5} style={{ opacity: 0.4 }} />
              <Typography variant="h6" style={{ margin: 0 }}>{i18n.t("kanban.emptyBoard")}</Typography>
              <Typography variant="body2" style={{ opacity: 0.7, textAlign: "center", maxWidth: 360 }}>
                {i18n.t("kanban.emptyBoardDescription")}
              </Typography>
              <button
                type="button"
                className={actionBtnClasses.dialogBtn}
                onClick={(e) => handleAddColumn(null, null, e.currentTarget)}
                style={{ marginTop: 4 }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
                {i18n.t("kanban.createFirstColumn")}
              </button>
            </div>
          )}
          {lanes.map((lane) => (
            <div
              key={lane.id}
              className={classes.lane}
              onDragOver={(e) => onLaneDragOver(e, lane.id)}
              onDrop={(e) => onDrop(e, lane.id)}
            >
              {/* header */}
              <LaneHeader lane={lane} classes={classes} onAddColumn={handleAddColumn} onRename={handleRenameColumn} onEdit={handleEditColumnRequest} onDelete={handleDeleteColumnRequest} onAddCard={openNewCard} currencySymbol={currency?.symbol || "R$"} currencyLocale={currency?.locale || "pt-BR"} />
              <div className={classes.laneDivider} />

              {/* cards */}
              <div className={classes.laneCards} data-lane-cards>
                {(() => {
                  const visibleTickets = lane.tickets.filter((t) => !(dragState && dragState.ticketId === t.id));
                  const showPlaceholder = dragState && dragState.targetLaneId === lane.id;
                  const placeholderIdx = dragState ? dragState.targetIndex : -1;
                  const insertAt = placeholderIdx >= 0 ? Math.min(placeholderIdx, visibleTickets.length) : visibleTickets.length;
                  const placeholder = showPlaceholder ? <div key="placeholder" className={classes.cardPlaceholder} /> : null;

                  const items = [];
                  for (let i = 0; i <= visibleTickets.length; i++) {
                    if (i === insertAt && placeholder) items.push(placeholder);
                    if (i < visibleTickets.length) {
                      const ticket = visibleTickets[i];
                      items.push(
                        <KanbanCard
                          key={ticket.id}
                          ticket={ticket}
                          laneId={lane.id}
                          laneColor={lane.color}
                          classes={classes}
                          onDragStart={onDragStart}
                          onDragEnd={onDragEnd}
                          goToTicket={goToTicket}
                          openTicketDrawer={openTicketDrawer}
                          lanes={lanes}
                          onMoveCard={handleCardMove}
                          onDeleteTicket={handleDeleteTicket}
                          onToggleMute={handleToggleMute}
                          onCloseTicket={handleCloseTicket}
                          onTransfer={(ticketId) => { setTransferTicketId(ticketId); setTransferModalOpen(true); }}
                          onEditContact={(ticketArg) => {
                            const laneTag = ticketArg?.tags?.find((tt) => tags.some((bt) => bt.id === tt.id));
                            const laneId = laneTag?.id ? String(laneTag.id) : "lane0";
                            const uid = ticketArg?.userId ? String(ticketArg.userId) : "";
                            setEditContactModal({
                              open: true,
                              contactId: ticketArg?.contact?.id || null,
                              ticketId: ticketArg?.id || null,
                              laneId,
                              originalLaneId: laneId,
                              userId: uid,
                              originalUserId: uid,
                            });
                          }}
                          onMoveToBoard={(ticketArg, anchorEl) => {
                            const rect = anchorEl?.getBoundingClientRect?.();
                            const anchorPosition = rect ? { top: rect.bottom + 4, left: rect.left } : null;
                            setMoveBoardPopover({ open: true, anchorPosition, ticketId: ticketArg?.id || null, boardId: "", laneId: "", lanes: [], loading: false });
                          }}
                          onRefresh={fetchTickets}
                          formatMoney={formatCurrency}
                          currencyInfo={currency}
                          getAvailableCurrencies={getAvailableCurrencies}
                          updateCurrency={updateCurrency}
                          isSuper={user?.super}
                        />
                      );
                    }
                  }
                  return items;
                })()}
              </div>

            </div>
          ))}
        </div>
      </div>

      {/* Delete Column Modal */}
      <ChatiaDialog
        open={deleteColModal.open}
        onClose={() => setDeleteColModal({ ...deleteColModal, open: false })}
        title={i18n.t("kanban.deleteColumnDialog.titleTemplate", { name: deleteColModal.laneName })}
        maxWidth="sm"
        saveText={deleteColModal.ticketCount > 0 ? i18n.t("kanban.deleteColumnDialog.deleteAndTransfer") : i18n.t("kanban.deleteColumnDialog.delete")}
        saveType="button"
        saveDisabled={deleteColModal.ticketCount > 0 && !deleteTransferTo}
        saveDisabledReason={deleteColModal.ticketCount > 0 && !deleteTransferTo ? i18n.t("kanban.deleteColumnDialog.selectDestination") : undefined}
        onSave={() => handleDeleteColumnConfirm(deleteColModal.laneId, deleteColModal.ticketCount > 0 ? deleteTransferTo : null)}
      >
        {deleteColModal.ticketCount > 0 ? (
          <>
            <Typography variant="body2" style={{ marginBottom: 12 }}>
              {i18n.t("kanban.deleteColumnDialog.columnHasCardsBefore")} <b>{deleteColModal.ticketCount}</b> {i18n.t("kanban.deleteColumnDialog.columnHasCardsAfter")}
            </Typography>
            <ChatiaSelect
              value={deleteTransferTo}
              onChange={(e) => setDeleteTransferTo(e.target.value)}
              placeholder={i18n.t("kanban.deleteColumnDialog.selectColumnPlaceholder")}
              displayEmpty
              options={lanes
                .filter((l) => l.id !== deleteColModal.laneId)
                .map((l) => ({
                  value: l.id,
                  label: l.name,
                  icon: <span style={{ display: "inline-block", width: 10, height: 10, borderRadius: "50%", background: l.color }} />,
                }))}
            />
          </>
        ) : (
          <Typography variant="body2">
            {i18n.t("kanban.deleteColumnDialog.confirmBodyBefore")} <b>"{deleteColModal.laneName}"</b>{i18n.t("kanban.deleteColumnDialog.confirmBodyAfter")}
          </Typography>
        )}
      </ChatiaDialog>

      {/* Transfer Modal */}
      <TransferTicketModalCustom
        modalOpen={transferModalOpen}
        onClose={() => { setTransferModalOpen(false); setTransferTicketId(null); fetchTickets(); }}
        ticketid={transferTicketId}
      />

      {/* Contact Drawer */}
      <Drawer
        className={classes.contactDrawer}
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <div className={classes.contactDrawerHeader}>
          <Typography className={classes.contactDrawerTitle}>
            {i18n.t("kanban.contactDrawer.title")}
          </Typography>
          <IconButton
            size="small"
            className={classes.contactDrawerClose}
            onClick={() => setDrawerOpen(false)}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
          </IconButton>
        </div>
        {selectedTicket && (
          <ContactDrawer
            open={drawerOpen}
            handleDrawerClose={() => setDrawerOpen(false)}
            contact={selectedTicket.contact}
            ticket={selectedTicket}
            embedded
          />
        )}
      </Drawer>

      <ConfirmationModal
        title={deleteBoardConfirm.board ? i18n.t("kanban.deleteBoardDialog.titleTemplate", { name: deleteBoardConfirm.board.name }) : ""}
        open={deleteBoardConfirm.open}
        onClose={() => setDeleteBoardConfirm({ open: false, board: null })}
        onConfirm={handleConfirmDeleteBoard}
      >
        {i18n.t("kanban.deleteBoardDialog.body")}
      </ConfirmationModal>

      <AddColumnPopover
        open={addColPopover.open}
        anchorEl={addColPopover.anchorEl}
        onClose={handleAddColumnClose}
        onSave={handleAddColumnSave}
        saving={addColSaving}
        initialName={addColPopover.initialName || ""}
        initialColor={addColPopover.initialColor || "#1976d2"}
        title={
          addColPopover.editingLaneId
            ? i18n.t("kanban.addColumn.edit")
            : addColPopover.position === "before"
            ? i18n.t("kanban.addColumn.before")
            : addColPopover.position === "after"
            ? i18n.t("kanban.addColumn.after")
            : i18n.t("kanban.addColumn.first")
        }
      />

      <ChatiaPopover
        open={newBoardPopover.open}
        anchorEl={newBoardPopover.anchorEl}
        onClose={() => !creatingBoard && setNewBoardPopover({ open: false, anchorEl: null })}
        title={i18n.t("kanban.newBoard.title")}
        paperStyle={{ minWidth: 320 }}
        contentStyle={{ padding: 12, maxHeight: "none", overflow: "visible" }}
      >
        <div>
          <TextField
            label={i18n.t("kanban.newBoard.nameLabel")}
            value={newBoardName}
            onChange={(e) => setNewBoardName(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleCreateBoard(); } }}
            variant="outlined"
            margin="dense"
            autoFocus
            fullWidth
            InputProps={{ style: { borderRadius: 12 } }}
          />
          <div style={{ marginTop: 12 }}>
            <ChatiaSelect
              label={i18n.t("kanban.template")}
              value={newBoardTemplate}
              onChange={(e) => setNewBoardTemplate(e.target.value)}
              placeholder={i18n.t("kanban.newBoard.templateEmpty")}
              options={[
                { value: "", label: i18n.t("kanban.newBoard.templateEmpty") },
                { value: "pos-vendas", label: i18n.t("kanban.newBoard.templatePostSales") },
              ]}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
            <button
              type="button"
              className={actionBtnClasses.dialogBtn}
              onClick={handleCreateBoard}
              disabled={!newBoardName.trim() || creatingBoard}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 14L8.5 17.5L19 6.5" /></svg>
              {creatingBoard ? i18n.t("kanban.newBoard.saving") : i18n.t("kanban.newBoard.save")}
            </button>
          </div>
        </div>
      </ChatiaPopover>

      <ChatiaPopover
        open={moveBoardPopover.open}
        anchorReference="anchorPosition"
        anchorPosition={moveBoardPopover.anchorPosition || { top: 0, left: 0 }}
        onClose={() => setMoveBoardPopover({ open: false, anchorPosition: null, ticketId: null, boardId: "", laneId: "", lanes: [], loading: false })}
        title={i18n.t("kanban.moveBoard.title")}
        paperStyle={{ minWidth: 320 }}
        contentStyle={{ padding: 12, maxHeight: "none", overflow: "visible" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <ChatiaSelect
            label={i18n.t("kanban.moveBoard.board")}
            value={moveBoardPopover.boardId}
            onChange={(e) => handleMoveBoardBoardChange(e.target.value)}
            options={boards.filter((b) => b.id !== activeBoardId).map((b) => ({ value: b.id, label: b.name }))}
          />
          <ChatiaSelect
            label={moveBoardPopover.loading ? i18n.t("kanban.moveBoard.loadingColumns") : i18n.t("kanban.moveBoard.column")}
            value={moveBoardPopover.laneId}
            onChange={(e) => setMoveBoardPopover((prev) => ({ ...prev, laneId: e.target.value }))}
            disabled={!moveBoardPopover.boardId || moveBoardPopover.loading}
            options={moveBoardPopover.lanes.map((l) => ({
              value: String(l.id),
              label: l.name,
              icon: <span style={{ display: "inline-block", width: 10, height: 10, borderRadius: "50%", background: l.color }} />,
            }))}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
            <button
              type="button"
              className={actionBtnClasses.dialogBtn}
              onClick={handleMoveBoardConfirm}
              disabled={!moveBoardPopover.boardId || !moveBoardPopover.laneId}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 14L8.5 17.5L19 6.5" /></svg>
              {i18n.t("kanban.moveBoard.move")}
            </button>
          </div>
        </div>
      </ChatiaPopover>

      <ContactModal
        open={newCardModal.open}
        onClose={() => setNewCardModal({ open: false, laneId: null })}
        onSave={handleNewCardContactSaved}
        kanbanLaneSelect={{
          lanes,
          value: newCardModal.laneId,
          onChange: (v) => setNewCardModal((prev) => ({ ...prev, laneId: v })),
        }}
      />

      <ContactModal
        open={editContactModal.open}
        contactId={editContactModal.contactId}
        onClose={() => setEditContactModal({ open: false, contactId: null, ticketId: null, laneId: null, originalLaneId: null, userId: "", originalUserId: "" })}
        onSaveSuccess={async () => {
          const { ticketId, laneId, originalLaneId, userId, originalUserId } = editContactModal;
          if (ticketId && laneId && laneId !== originalLaneId) {
            try {
              await api.delete(`/ticket-tags/${ticketId}`);
              if (laneId !== "lane0") await api.put(`/ticket-tags/${ticketId}/${laneId}`);
            } catch (e) { console.log(e); }
          }
          if (ticketId && String(userId || "") !== String(originalUserId || "")) {
            try {
              await api.put(`/tickets/${ticketId}`, { userId: userId ? Number(userId) : null });
            } catch (e) { console.log(e); }
          }
          fetchTickets();
        }}
        kanbanLaneSelect={{
          lanes,
          value: editContactModal.laneId,
          onChange: (v) => setEditContactModal((prev) => ({ ...prev, laneId: v })),
        }}
        kanbanUserSelect={{
          users: usersList,
          value: editContactModal.userId,
          onChange: (v) => setEditContactModal((prev) => ({ ...prev, userId: v })),
        }}
      />

      <ChatiaDialog
        open={deleteTicketModal.open}
        onClose={() => setDeleteTicketModal({ open: false, ticketId: null, contactId: null, name: "", alsoDeleteContact: false })}
        title={deleteTicketModal.name ? i18n.t("kanban.deleteTicket.titleTemplate", { name: deleteTicketModal.name }) : i18n.t("kanban.deleteTicket.titleGeneric")}
        maxWidth="sm"
        saveText={deleteTicketModal.alsoDeleteContact ? i18n.t("kanban.deleteTicket.saveWithContact") : i18n.t("kanban.deleteTicket.saveOnly")}
        saveType="button"
        onSave={handleDeleteTicketConfirm}
      >
        <Typography variant="body2" style={{ marginBottom: 12 }}>
          {i18n.t("kanban.deleteTicket.body")}
        </Typography>
        <label style={{ display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13 }}>
          <Checkbox
            className={classes.customCheckbox}
            icon={<CheckboxUnchecked />}
            checkedIcon={<CheckboxChecked />}
            checked={deleteTicketModal.alsoDeleteContact}
            onChange={(e) => setDeleteTicketModal((prev) => ({ ...prev, alsoDeleteContact: e.target.checked }))}
            size="small"
          />
          <span>{i18n.t("kanban.deleteTicket.alsoDeleteContact")}</span>
        </label>
      </ChatiaDialog>
    </div>
  );
};

/* ─── Lane Header ─── */
const LaneHeader = React.memo(({ lane, classes, onAddColumn, onRename, onEdit, onDelete, onAddCard, currencySymbol, currencyLocale }) => {
  const theme = useTheme();
  const [menuAnchor, setMenuAnchor] = useState(null);
  const menuBtnRef = useRef(null);
  const close = () => setMenuAnchor(null);
  const isDefault = lane.id === "lane0";

  const [editing, setEditing] = useState(false);
  const [editValue, setEditValue] = useState(lane.name);
  const inputRef = useRef(null);

  const startEditing = () => {
    if (isDefault) return;
    setEditValue(lane.name);
    setEditing(true);
  };

  useEffect(() => {
    if (editing && inputRef.current) {
      const el = inputRef.current;
      el.focus();
      el.select();
    }
  }, [editing]);

  const commitEdit = () => {
    const trimmed = (editValue || "").trim();
    setEditing(false);
    if (trimmed && trimmed !== lane.name) {
      onRename(lane.id, trimmed);
    }
  };

  const cancelEdit = () => {
    setEditValue(lane.name);
    setEditing(false);
  };

  return (
    <div className={classes.laneHeader}>
      <div className={classes.laneHeaderTop}>
        <div className={classes.laneDot} style={{ background: lane.color }} />
        {editing ? (
          <input
            ref={inputRef}
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onBlur={commitEdit}
            onKeyDown={(e) => {
              if (e.key === "Enter") { e.preventDefault(); commitEdit(); }
              else if (e.key === "Escape") { e.preventDefault(); cancelEdit(); }
            }}
            className={classes.laneName}
            style={{
              background: "transparent",
              border: "none",
              outline: "none",
              font: "inherit",
              color: "inherit",
              padding: 0,
              margin: 0,
              minWidth: 40,
              flex: "0 1 auto",
              borderBottom: "1px dashed currentColor",
            }}
          />
        ) : (
          <AppTooltip title={lane.name} placement="top" arrow enterDelay={400}>
            <span
              className={classes.laneName}
              onDoubleClick={startEditing}
              style={{ cursor: isDefault ? "default" : "text" }}
            >
              {lane.name}
            </span>
          </AppTooltip>
        )}
        <div style={{ display: "flex", alignItems: "center", gap: 4, marginLeft: "auto" }}>
          <span style={{ fontSize: 11, fontWeight: 500, opacity: lane.total > 0 ? 0.55 : 0.3 }}>{currencySymbol} {Math.round(lane.total || 0).toLocaleString(currencyLocale)}</span>
          <span className={classes.laneCount}>{lane.tickets.length}</span>
        </div>
        <IconButton ref={menuBtnRef} className={classes.laneMenuBtn} size="small" onClick={(e) => setMenuAnchor(e.currentTarget)}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" opacity="0.5">
            <circle cx="12" cy="5" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="12" cy="19" r="2" />
          </svg>
        </IconButton>
        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={close} PaperProps={{ style: { borderRadius: 12, minWidth: 190, padding: "4px 0", marginTop: -5, marginLeft: 30, background: theme.mode === "dark" ? "#121212" : "#ffffff" } }}>
          <MenuItem dense onClick={() => { close(); onAddCard && onAddCard(lane); }} style={{ gap: 8, fontSize: 13 }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"/></svg>
            {i18n.t("kanban.laneMenu.addCard")}
          </MenuItem>
          <div style={{ height: 1, background: "rgba(128,128,128,0.15)", margin: "4px 0" }} />
          {!isDefault && (
            <MenuItem dense onClick={() => { close(); startEditing(); }} style={{ gap: 8, fontSize: 13 }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5z"/></svg>
              {i18n.t("kanban.laneMenu.rename")}
            </MenuItem>
          )}
          {onEdit && lane.id !== "lane0" && (
            <MenuItem dense onClick={() => { const anchor = menuBtnRef.current; close(); onEdit(lane, anchor); }} style={{ gap: 8, fontSize: 13 }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
              {i18n.t("kanban.laneMenu.edit")}
            </MenuItem>
          )}
          <MenuItem dense onClick={() => { const anchor = menuBtnRef.current; close(); onAddColumn("before", lane.id, anchor); }} style={{ gap: 8, fontSize: 13 }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"/></svg>
            {i18n.t("kanban.laneMenu.addBefore")}
          </MenuItem>
          <MenuItem dense onClick={() => { const anchor = menuBtnRef.current; close(); onAddColumn("after", lane.id, anchor); }} style={{ gap: 8, fontSize: 13 }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"/></svg>
            {i18n.t("kanban.laneMenu.addAfter")}
          </MenuItem>
          {!isDefault && [
            <div key="lane-menu-divider" style={{ height: 1, background: "rgba(128,128,128,0.15)", margin: "4px 0" }} />,
            lane.isLocked ? (
              <MenuItem
                key="lane-menu-delete-locked"
                dense
                disabled
                style={{ gap: 8, fontSize: 13, opacity: 0.7 }}
                title={(() => {
                  const reasons = Array.isArray(lane.lockReasons) ? lane.lockReasons : [];
                  if (reasons.includes("system_default"))
                    return i18n.t("kanban.laneLock.systemDefaultTooltip");
                  if (reasons.includes("deal_outcome"))
                    return i18n.t("kanban.laneLock.dealOutcomeTooltipTemplate", {
                      outcome: lane.dealOutcome === "won"
                        ? i18n.t("kanban.laneLock.dealWon")
                        : i18n.t("kanban.laneLock.dealLost"),
                    });
                  if (reasons.includes("mapping") && Array.isArray(lane.lockedBy) && lane.lockedBy.length > 0)
                    return i18n.t("kanban.laneLock.mappingTooltipTemplate", {
                      names: lane.lockedBy.map(l => l.name).join(", "),
                    });
                  return i18n.t("kanban.laneLock.protectedTooltip");
                })()}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                <span style={{ position: "relative", top: 1 }}>
                  {(() => {
                    const reasons = Array.isArray(lane.lockReasons) ? lane.lockReasons : [];
                    if (reasons.includes("system_default")) return i18n.t("kanban.laneLock.systemDefaultLabel");
                    if (reasons.includes("deal_outcome")) return i18n.t("kanban.laneLock.dealOutcomeLabel");
                    if (reasons.includes("mapping")) return i18n.t("kanban.laneLock.mappingLabel");
                    return i18n.t("kanban.laneLock.protectedLabel");
                  })()}
                </span>
              </MenuItem>
            ) : (
              <MenuItem key="lane-menu-delete" dense onClick={() => { close(); onDelete(lane); }} style={{ gap: 8, fontSize: 13, color: "#c62828" }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#c62828" strokeWidth="1.5" strokeLinecap="round" style={{ flexShrink: 0, marginTop: -1 }}>
                  <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" />
                  <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" />
                  <path d="M9.5 16.5L9.5 10.5" />
                  <path d="M14.5 16.5L14.5 10.5" />
                </svg>
                <span style={{ color: "#c62828", position: "relative", top: 1 }}>{i18n.t("kanban.laneMenu.deleteColumn")}</span>
              </MenuItem>
            )
          ]}
        </Menu>
      </div>
    </div>
  );
});

/* ─── Kanban Card ─── */
const ContactAvatarFlag = ({ contact, size = 28, classes }) => {
  const num = contact?.number;
  let flag = null;
  if (num) {
    try {
      let formatted = String(num).trim();
      if (!formatted.startsWith("+")) formatted = "+" + formatted;
      if (/^\+521\d{10}$/.test(formatted)) formatted = formatted.replace(/^\+521/, "+52");
      const parsed = parsePhoneNumber(formatted);
      if (parsed && parsed.isValid() && parsed.country) {
        let countryName = parsed.country;
        try {
          const lang = (typeof navigator !== "undefined" && navigator.language) || "pt-BR";
          const display = new Intl.DisplayNames([lang], { type: "region" });
          countryName = display.of(parsed.country) || parsed.country;
        } catch (e) {}
        flag = (
          <AppTooltip title={countryName} placement="right">
            <span className={classes.cardFlag}>
              <ReactCountryFlag countryCode={parsed.country} svg style={{ width: 18, height: 13, display: "block" }} />
            </span>
          </AppTooltip>
        );
      }
    } catch (e) {}
  }
  return (
    <div className={classes.cardAvatarWrap} style={{ width: size, height: size }}>
      <ContactAvatar contact={contact} className={classes.cardContactAvatar} style={{ width: size, height: size }} />
      {flag}
    </div>
  );
};

const KanbanCard = React.memo(({ ticket, laneId, laneColor, classes, onDragStart, onDragEnd, goToTicket, openTicketDrawer, lanes, onMoveCard, onDeleteTicket, onToggleMute, onCloseTicket, onTransfer, onEditContact, onMoveToBoard, onRefresh, formatMoney: fmtMoney, currencyInfo, getAvailableCurrencies, updateCurrency, isSuper }) => {
  const btnClasses = useActionBtnStyles();
  const theme = useTheme();
  const [dragging, setDragging] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [tagsAnchor, setTagsAnchor] = useState(null);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [editScheduleId, setEditScheduleId] = useState(null);
  const [scheduleAnchor, setScheduleAnchor] = useState(null);
  const [schedules, setSchedules] = useState([]);
  const [budgetAnchor, setBudgetAnchor] = useState(null);
  const [budgetInput, setBudgetInput] = useState("");
  const [newProdName, setNewProdName] = useState("");
  const [newProdValue, setNewProdValue] = useState("");
  const [newProdStatus, setNewProdStatus] = useState("budget");
  const [editingProdId, setEditingProdId] = useState(null);
  const [editingProdName, setEditingProdName] = useState("");
  const [editingProdValue, setEditingProdValue] = useState("");
  const [editingProdStatus, setEditingProdStatus] = useState("budget");
  const [currencyAnchor, setCurrencyAnchor] = useState(null);
  const [currencySearch, setCurrencySearch] = useState("");
  const [notesAnchor, setNotesAnchor] = useState(null);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editingNoteText, setEditingNoteText] = useState("");
  const [followUpAnchor, setFollowUpAnchor] = useState(null);
  const [followUpOpen, setFollowUpOpen] = useState(false);
  const [followUps, setFollowUps] = useState([]);
  const [newFollowNote, setNewFollowNote] = useState("");
  const [newFollowDate, setNewFollowDate] = useState("");
  const [editingFollowId, setEditingFollowId] = useState(null);
  const [editingFollowNote, setEditingFollowNote] = useState("");
  const [chatDialogOpen, setChatDialogOpen] = useState(false);
  const contactName = ticket.contact?.name || i18n.t("kanban.card.noName");
  const updatedAt = ticket.updatedAt ? parseISO(ticket.updatedAt) : null;

  const fetchSchedules = useCallback(async () => {
    if (!ticket.contact?.id) return;
    try {
      const { data } = await api.get("/schedules", { params: { contactId: ticket.contact.id } });
      setSchedules(data.schedules || []);
    } catch { /* ignore */ }
  }, [ticket.contact?.id]);

  const fetchNotes = useCallback(async () => {
    if (!ticket.contact?.id) return;
    try {
      const { data } = await api.get("/ticket-notes/list", { params: { contactId: ticket.contact.id, ticketId: ticket.id } });
      if (Array.isArray(data)) setNotes(data);
      else if (data && Array.isArray(data.notes)) setNotes(data.notes);
      else if (data && Array.isArray(data.ticketNotes)) setNotes(data.ticketNotes);
      else setNotes([]);
    } catch { /* ignore */ }
  }, [ticket.contact?.id]);

  const fetchFollowUps = useCallback(async () => {
    if (!ticket.contact?.id) return;
    try {
      const { data } = await api.get("/contact-follow-ups", { params: { contactId: ticket.contact.id } });
      setFollowUps(Array.isArray(data) ? data : []);
    } catch { setFollowUps([]); }
  }, [ticket.contact?.id]);

  // fetch once on mount with stagger to avoid flooding
  // eslint-disable-next-line
  useEffect(() => {
    const delay = Math.random() * 2000;
    const t = setTimeout(() => { fetchSchedules(); fetchNotes(); fetchFollowUps(); }, delay);
    return () => clearTimeout(t);
  }, []);

  const handleScheduleClick = async (e) => {
    e.stopPropagation();
    const el = e.currentTarget;
    if (!ticket.contact?.id) { setScheduleModalOpen(true); return; }
    try {
      const { data } = await api.get("/schedules", { params: { contactId: ticket.contact.id } });
      const list = data.schedules || data || [];
      setSchedules(Array.isArray(list) ? list : []);
      if (Array.isArray(list) && list.length > 0) setScheduleAnchor(el);
      else setScheduleModalOpen(true);
    } catch { setScheduleModalOpen(true); }
  };

  const handleMenuOpen = (e) => { e.stopPropagation(); setMenuAnchor(e.currentTarget); };
  const handleMenuClose = () => { setMenuAnchor(null); };
  const handleMoveNext = () => {
    handleMenuClose();
    const idx = lanes.findIndex((l) => l.id === laneId);
    const nextLane = lanes[idx + 1] || lanes[0];
    if (nextLane && nextLane.id !== laneId && onMoveCard) onMoveCard(ticket.id, laneId, nextLane.id);
  };

  return (
    <div
      className={`${classes.card} ${dragging ? classes.cardDragging : ""}`}
      data-card-id={ticket.id}
      draggable
      onDragStart={(e) => { setDragging(true); onDragStart(e, ticket.id, laneId); }}
      onDragEnd={(e) => { setDragging(false); onDragEnd(e); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => { if (!menuAnchor) setHovered(false); }}
      style={{
        position: "relative",
        // Borda esquerda sempre herda a cor da lane (acompanha mudanças de cor da coluna).
        borderLeftWidth: "4px",
        borderLeftStyle: "solid",
        borderLeftColor: laneColor || "transparent",
        // Won/Lost têm prioridade: sobrescrevem com cores semânticas fixas.
        ...(ticket.dealStatus === "won"
          ? { borderLeftWidth: "4px", borderLeftColor: "#2e7d32" }
          : ticket.dealStatus === "lost"
            ? { borderLeftWidth: "4px", borderLeftColor: "#c62828" }
            : {}),
      }}
    >
      {/* menu 3 dots - hover only */}
      {(hovered || Boolean(menuAnchor)) && (
        <AppTooltip titleKey="kanban.card.menu">
          <IconButton
            size="small"
            className={classes.cardMenuBtn}
            onClick={handleMenuOpen}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="5" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="12" cy="19" r="2" />
            </svg>
          </IconButton>
        </AppTooltip>
      )}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        PaperProps={{ style: { borderRadius: 12, minWidth: 180, padding: "5px 0 4px", marginLeft: 30, background: theme.mode === "dark" ? "#121212" : "#ffffff" } }}
        TransitionProps={{ onExited: () => setHovered(false) }}
      >
        <MenuItem dense onClick={(e) => { e.stopPropagation(); handleMenuClose(); openTicketDrawer(ticket); }} style={{ gap: 8, fontSize: 13 }}>
          <UserRound size={16} strokeWidth={1.5} style={{ marginTop: -1 }} />
          <span style={{ position: "relative", top: 1 }}>{i18n.t("kanban.cardMenu.contactDetails")}</span>
        </MenuItem>
        <MenuItem dense onClick={(e) => { e.stopPropagation(); handleMenuClose(); if (onEditContact && ticket.contact?.id) onEditContact(ticket); }} style={{ gap: 8, fontSize: 13 }}>
          <span style={{ display: "inline-flex", width: 16, height: 16, alignItems: "center", justifyContent: "center", marginTop: -1, flexShrink: 0 }}>
            <Pencil size={16} strokeWidth={1.5} />
          </span>
          <span style={{ position: "relative", top: 1 }}>{i18n.t("kanban.cardMenu.editContact")}</span>
        </MenuItem>
        <MenuItem dense onClick={(e) => { e.stopPropagation(); handleMoveNext(); }} style={{ gap: 8, fontSize: 13 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: -1 }}><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
          <span style={{ position: "relative", top: 1 }}>{i18n.t("kanban.cardMenu.moveCard")}</span>
        </MenuItem>
        {/* Mover para outro quadro removido — sistema usa apenas um quadro */}
        <MenuItem dense onClick={(e) => { e.stopPropagation(); handleMenuClose(); onTransfer(ticket.id); }} style={{ gap: 8, fontSize: 13 }}>
          <ArrowUpRight size={16} strokeWidth={1.5} style={{ marginTop: -1 }} />
          <span style={{ position: "relative", top: 1 }}>{i18n.t("kanban.cardMenu.transfer")}</span>
        </MenuItem>
        <MenuItem dense onClick={(e) => { e.stopPropagation(); handleMenuClose(); onToggleMute(ticket.id); }} style={{ gap: 8, fontSize: 13 }}>
          <span style={{ marginTop: -1, display: "flex" }}>{ticket.mutedUntil ? <BellOffIcon width={16} height={16} /> : <BellIcon width={16} height={16} />}</span>
          <span style={{ position: "relative", top: 1 }}>{ticket.mutedUntil ? i18n.t("kanban.cardMenu.unmute") : i18n.t("kanban.cardMenu.mute")}</span>
        </MenuItem>
        <div style={{ height: 1, background: "rgba(128,128,128,0.15)", margin: "4px 0" }} />
        <MenuItem dense onClick={(e) => { e.stopPropagation(); handleMenuClose(); onCloseTicket(ticket.id); }} style={{ gap: 8, fontSize: 13 }}>
          <LuX size={16} strokeWidth={1.5} style={{ marginTop: -1 }} />
          <span style={{ position: "relative", top: 1 }}>{i18n.t("kanban.cardMenu.closeTicket")}</span>
        </MenuItem>
        <MenuItem dense onClick={(e) => { e.stopPropagation(); handleMenuClose(); if (onDeleteTicket) onDeleteTicket(ticket.id); }} style={{ gap: 8, fontSize: 13, color: "#c62828" }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#c62828" strokeWidth="1.5" strokeLinecap="round" style={{ flexShrink: 0, marginTop: -1 }}>
            <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" />
            <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" />
            <path d="M9.5 16.5L9.5 10.5" />
            <path d="M14.5 16.5L14.5 10.5" />
          </svg>
          <span style={{ color: "#c62828", position: "relative", top: 1 }}>{i18n.t("kanban.cardMenu.deleteLead")}</span>
        </MenuItem>
      </Menu>
      {/* row 1: left icons + avatar + name + value */}
      <div className={classes.cardTopRow}>
        <div className={classes.cardLeftCol}>
          <span className={classes.cardDrag}><DragIcon /></span>
          {ticket.mutedUntil && <span style={{ display: "flex", opacity: 0.4 }}><BellOffIcon /></span>}
        </div>
        <ContactAvatarFlag contact={ticket.contact} size={44} classes={classes} />
        <div className={classes.cardInfo}>
          <div className={classes.cardNameRow}>
            {(() => {
              const source = ticket.contact?.leadSource || ticket.channel;
              const tip = ticket.contact?.leadSource
                ? getLeadSourceLabel(ticket.contact.leadSource) || ticket.contact.leadSource
                : (ticket.whatsapp?.name || ticket.channel);
              return (
                <AppTooltip title={tip}>
                  <span style={{ display: "flex", flexShrink: 0 }}><ChannelIcon channel={source} size={18} /></span>
                </AppTooltip>
              );
            })()}
            <span className={classes.cardName}>{maskTitleIfPhone(contactName)}</span>
          </div>
          <div className={classes.cardLastMsg}>
            {(() => {
              const raw = (ticket.lastMessage || "").replace(/^>\s?[^\n]+\n?/, "").trim();
              const lastMsg = ticket.messages && ticket.messages[0];
              const mType = lastMsg?.mediaType;
              const italic = { fontStyle: "italic", opacity: 0.85 };
              const svgBase = { width: 14, height: 14, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", style: { marginRight: 4, verticalAlign: "middle", flexShrink: 0 } };
              const imgIcon = (
                <svg {...svgBase}>
                  <circle cx="7.5" cy="7.5" r="1.5" />
                  <path d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z" />
                  <path d="M5 21C9.37246 15.775 14.2741 8.88406 21.4975 13.5424" />
                </svg>
              );
              const videoIcon = (
                <svg {...svgBase}>
                  <path d="M17.7001 21.3351C16.5281 21.4998 14.9996 21.4998 12.9501 21.4998H11.0501C7.01955 21.4998 5.0043 21.4998 3.75218 20.2476C2.50006 18.9955 2.50006 16.9803 2.50006 12.9498V11.0498C2.50006 7.01925 2.50006 5.00399 3.75218 3.75187C5.0043 2.49976 7.01955 2.49976 11.0501 2.49976H12.9501C16.9806 2.49976 18.9958 2.49976 20.2479 3.75187C21.5001 5.00399 21.5001 7.01925 21.5001 11.0498V12.9498C21.5001 14.158 21.5001 15.1851 21.4663 16.0648C21.4393 16.7699 21.4258 17.1224 21.1588 17.2541C20.8918 17.3859 20.5932 17.1746 19.9958 16.752L18.6501 15.7998" />
                  <path d="M14.9453 12.3948C14.7686 13.0215 13.9333 13.4644 12.2629 14.3502C10.648 15.2064 9.8406 15.6346 9.18992 15.4625C8.9209 15.3913 8.6758 15.2562 8.47812 15.07C8 14.6198 8 13.7465 8 12C8 10.2535 8 9.38018 8.47812 8.92995C8.6758 8.74381 8.9209 8.60868 9.18992 8.53753C9.8406 8.36544 10.648 8.79357 12.2629 9.64983C13.9333 10.5356 14.7686 10.9785 14.9453 11.6052C15.0182 11.8639 15.0182 12.1361 14.9453 12.3948Z" />
                </svg>
              );
              const audioIcon = (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 4, verticalAlign: "middle", flexShrink: 0 }}>
                  <path d="M17 7V11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7Z" />
                  <path d="M17 7H14M17 11H14" />
                  <path d="M20 11C20 15.4183 16.4183 19 12 19M12 19C7.58172 19 4 15.4183 4 11M12 19V22M12 22H15M12 22H9" />
                </svg>
              );
              const fileIcon = (
                <svg {...svgBase}>
                  <path d="M20.4999 14V10C20.4999 6.22876 20.4999 4.34315 19.3284 3.17157C18.1568 2 16.2712 2 12.4999 2H11.5C7.72883 2 5.84323 2 4.67166 3.17156C3.50008 4.34312 3.50007 6.22872 3.50004 9.99993L3.5 13.9999C3.49997 17.7712 3.49995 19.6568 4.67153 20.8284C5.8431 22 7.72873 22 11.5 22H12.4999C16.2712 22 18.1568 22 19.3284 20.8284C20.4999 19.6569 20.4999 17.7712 20.4999 14Z" />
                  <path d="M8 7H16M8 12H16M8 17L12 17" />
                </svg>
              );
              const wrap = (icon, label) => <span style={italic}>{icon}{label}</span>;
              const mt = String(mType || "").toLowerCase();
              if (mt.startsWith("image") || mt === "sticker" || mt === "stickermessage") {
                if (mt.startsWith("sticker")) return wrap(imgIcon, i18n.t("kanban.card.media.sticker"));
                return wrap(imgIcon, i18n.t("kanban.card.media.image"));
              }
              if (mt.startsWith("video")) return wrap(videoIcon, i18n.t("kanban.card.media.video"));
              if (mt.startsWith("audio") || mt.startsWith("ptt")) return wrap(audioIcon, i18n.t("kanban.card.media.audio"));
              if (mt.startsWith("document") || mt.startsWith("application")) return wrap(fileIcon, i18n.t("kanban.card.media.document"));
              if (mt.startsWith("location")) return wrap(fileIcon, i18n.t("kanban.card.media.location"));
              if (mt.startsWith("vcard") || mt.startsWith("contact")) return wrap(fileIcon, i18n.t("kanban.card.media.contact"));
              if (!raw) return <span style={{ fontStyle: "italic", opacity: 0.7 }}>{i18n.t("kanban.card.noMessages")}</span>;
              if (/^data:image/.test(raw)) return wrap(fileIcon, i18n.t("kanban.card.media.location"));
              if (/BEGIN:VCARD/i.test(raw)) return wrap(fileIcon, i18n.t("kanban.card.media.contact"));
              if (/\.(jpe?g|png|gif|webp|bmp|heic)(\?.*)?$/i.test(raw)) return wrap(imgIcon, i18n.t("kanban.card.media.image"));
              if (/\.(mp4|mov|webm|mkv|avi)(\?.*)?$/i.test(raw)) return wrap(videoIcon, i18n.t("kanban.card.media.video"));
              if (/\.(ogg|mp3|wav|m4a|opus)(\?.*)?$/i.test(raw)) return wrap(audioIcon, i18n.t("kanban.card.media.audio"));
              if (/\.(pdf|docx?|xlsx?|pptx?|zip|rar|7z|csv|txt)(\?.*)?$/i.test(raw)) return wrap(fileIcon, i18n.t("kanban.card.media.document"));
              return raw;
            })()}
          </div>
          {(() => {
            const prodTotal = (ticket.contact?.products || []).reduce((s, p) => s + (Number(p.value) || 0), 0);
            const total = prodTotal || (Number(ticket.value) || 0);
            const sym = currencyInfo?.symbol || "R$";
            const formatted = Math.round(total).toLocaleString(currencyInfo?.locale || "pt-BR");
            return <span style={{ fontSize: 11.5, fontWeight: 500, opacity: total > 0 ? 0.6 : 0.3 }}>{sym} {formatted}</span>;
          })()}
        </div>
      </div>

      {/* row 2: tags */}
      <div className={classes.cardTags}>
        {ticket.whatsapp && (() => {
          const c = ticket.channel === "whatsapp" ? "#128C7E" : ticket.channel === "facebook" ? "#4267B2" : "#E1306C";
          return (
            <span className={classes.cardTag} style={{ backgroundColor: `color-mix(in srgb, ${c} 18%, transparent)`, color: c }}>
              <Radio size={8} strokeWidth={2.5} />
              <span className={classes.cardTagLabel}>{ticket.whatsapp.name?.toUpperCase()}</span>
            </span>
          );
        })()}
        {(() => {
          const c = ticket.queue?.color || "#7c7c7c";
          return (
            <span className={classes.cardTag} style={{ backgroundColor: `color-mix(in srgb, ${c} 18%, transparent)`, color: c }}>
              <GitBranch size={8} strokeWidth={2.5} />
              <span className={classes.cardTagLabel}>{ticket.queueId ? ticket.queue?.name?.toUpperCase() : "SEM FILA"}</span>
            </span>
          );
        })()}
        {ticket.user && (() => {
          const c = "#055bab";
          return (
            <span className={classes.cardTag} style={{ backgroundColor: `color-mix(in srgb, ${c} 18%, transparent)`, color: c }}>
              <UserRound size={8} strokeWidth={2.5} />
              <span className={classes.cardTagLabel}>{ticket.user.name?.toUpperCase()}</span>
            </span>
          );
        })()}
        <AppTooltip title={i18n.t("kanban.card.moveNext")}>
          <button className={classes.cardMoveArrow} onClick={(e) => { e.stopPropagation(); handleMoveNext(); }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
          </button>
        </AppTooltip>
      </div>

      {/* row 3: actions + time */}
      <div className={classes.cardActionsRow}>
        <AppTooltip title={i18n.t("kanban.card.notes")}>
          <span style={{ position: "relative", display: "inline-flex" }}>
            <button className={classes.cardActionBtn} onClick={(e) => { e.stopPropagation(); fetchNotes(); setNotesAnchor(e.currentTarget); }}><NotesIcon /></button>
            {Array.isArray(notes) && notes.length > 0 && (
              <>
                <span style={{ position: "absolute", top: 2, right: 2, width: 7, height: 7, borderRadius: "50%", background: "#42a5f5", zIndex: 2, pointerEvents: "none" }} />
                <span style={{ position: "absolute", top: 2, right: 2, width: 7, height: 7, borderRadius: "50%", background: "#42a5f5", zIndex: 1, pointerEvents: "none", animation: "tagPulse 2s ease-in-out infinite" }} />
              </>
            )}
          </span>
        </AppTooltip>
        <AppTooltip title={i18n.t("kanban.card.openChat")}>
          <span style={{ position: "relative", display: "inline-flex" }}>
            <button className={classes.cardActionBtn} onClick={(e) => { e.stopPropagation(); goToTicket(ticket.uuid); }}><ChatIcon /></button>
            {(() => {
              const unread = Number(ticket.unreadMessages) > 0;
              const readNotReplied = !unread && ticket.fromMe === false;
              if (!unread && !readNotReplied) return null;
              const color = unread ? "#ef5350" : "#f9a825";
              return (
                <>
                  <span style={{ position: "absolute", top: 2, right: 2, width: 7, height: 7, borderRadius: "50%", background: color, zIndex: 2, pointerEvents: "none" }} />
                  <span style={{ position: "absolute", top: 2, right: 2, width: 7, height: 7, borderRadius: "50%", background: color, zIndex: 1, pointerEvents: "none", animation: "tagPulse 2s ease-in-out infinite" }} />
                </>
              );
            })()}
          </span>
        </AppTooltip>
        <AppTooltip title={i18n.t("kanban.card.scheduledMessage")}>
          <span style={{ position: "relative", display: "inline-flex" }}>
            <button className={classes.cardActionBtn} onClick={handleScheduleClick}><ScheduleIcon /></button>
            {schedules.length > 0 && (() => {
              const hasPending = schedules.some(s => s.status === "PENDENTE");
              const badgeColor = hasPending ? "#f9a825" : "#66bb6a";
              return (
                <>
                  <span style={{
                    position: "absolute", top: 2, right: 2, width: 7, height: 7,
                    borderRadius: "50%", background: badgeColor, zIndex: 2, pointerEvents: "none",
                  }} />
                  <span style={{
                    position: "absolute", top: 2, right: 2, width: 7, height: 7,
                    borderRadius: "50%", background: badgeColor, zIndex: 1, pointerEvents: "none",
                    animation: "tagPulse 2s ease-in-out infinite",
                  }} />
                </>
              );
            })()}
          </span>
        </AppTooltip>
        {/* Follow-up removido a pedido — não faz parte do escopo do CRM */}
        <AppTooltip title={i18n.t("kanban.card.tags")}>
          <span style={{ position: "relative", display: "inline-flex" }}>
            <button
              className={classes.cardActionBtn}
              onClick={(e) => { e.stopPropagation(); setTagsAnchor(e.currentTarget); }}
            >
              <TagIcon size={16} strokeWidth={1.5} />
            </button>
            {ticket.contact?.tags?.length > 0 && (
              <>
                <span style={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: ticket.contact.tags[0]?.color || "#999",
                  zIndex: 2,
                  pointerEvents: "none",
                }} />
                <span style={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: ticket.contact.tags[0]?.color || "#999",
                  animation: "tagPulse 2s ease-in-out infinite",
                  zIndex: 1,
                  pointerEvents: "none",
                }} />
              </>
            )}
          </span>
        </AppTooltip>
        <AppTooltip title={i18n.t("kanban.card.budget")}>
          <span style={{ position: "relative", display: "inline-flex" }}>
            <button className={classes.cardActionBtn} onClick={(e) => { e.stopPropagation(); setBudgetInput(ticket.value ? String(ticket.value) : ""); setBudgetAnchor(e.currentTarget); }}>
              <DollarIcon />
            </button>
            {ticket.contact?.products?.some(p => p.value) && (
              <>
                <span style={{ position: "absolute", top: 2, right: 2, width: 7, height: 7, borderRadius: "50%", background: "#66bb6a", zIndex: 2, pointerEvents: "none" }} />
                <span style={{ position: "absolute", top: 2, right: 2, width: 7, height: 7, borderRadius: "50%", background: "#66bb6a", zIndex: 1, pointerEvents: "none", animation: "tagPulse 2s ease-in-out infinite" }} />
              </>
            )}
          </span>
        </AppTooltip>
        <span className={classes.cardTime}>
          {updatedAt ? (isSameDay(updatedAt, new Date()) ? format(updatedAt, "HH:mm") : format(updatedAt, "dd/MM/yyyy")) : ""}
        </span>
      </div>

      {/* Tags Popover */}
      <ChatiaPopover
        open={Boolean(tagsAnchor)}
        anchorEl={tagsAnchor}
        onClose={(e) => { if (e && e.stopPropagation) e.stopPropagation(); setTagsAnchor(null); if (onRefresh) onRefresh(); }}
        onClick={(e) => e.stopPropagation()}
        title={i18n.t("kanban.card.tags")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div style={{ minWidth: 280, padding: "8px 6px" }}>
          <TagsContainer contact={ticket.contact} />
        </div>
      </ChatiaPopover>

      {/* Schedules Popover */}
      <ChatiaPopover
        open={Boolean(scheduleAnchor)}
        anchorEl={scheduleAnchor}
        onClose={(e) => { if (e && e.stopPropagation) e.stopPropagation(); setScheduleAnchor(null); }}
        onClick={(e) => e.stopPropagation()}
        title={i18n.t("kanban.schedule.title")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        contentStyle={{ paddingLeft: 10, paddingRight: 0, paddingTop: 6, paddingBottom: 6, maxHeight: 250 }}
      >
        <div style={{ minWidth: 260, maxWidth: 300 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {schedules.map((s) => (
              <div key={s.id} style={{
                display: "flex", alignItems: "center", gap: 8, padding: "6px 10px",
                marginRight: 10, borderRadius: 8, background: "rgba(128,128,128,0.06)", fontSize: 12,
                border: theme.palette.type === "light" ? "1px solid rgba(0,0,0,0.06)" : "1px solid rgba(255,255,255,0.04)",
              }}>
                <span style={{
                  width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
                  background: s.status === "PENDENTE" ? "#f9a825" : (s.status === "ENVIADA" || s.status === "ENVIADO") ? "#66bb6a" : s.status === "ERRO" ? "#ef4444" : "#66bb6a",
                }} />
                <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {s.body || i18n.t("kanban.schedule.noBody")}
                </span>
                <span style={{ opacity: 0.5, fontSize: 10, flexShrink: 0 }}>
                  {s.sendAt ? format(parseISO(s.sendAt), "dd/MM HH:mm") : ""}
                </span>
                {s.status === "PENDENTE" && (
                  <AppTooltip titleKey="kanban.card.editSchedule">
                    <button
                      className={btnClasses.iconBtnEdit}
                      style={{ width: 22, height: 22 }}
                      onClick={(e) => { e.stopPropagation(); setScheduleAnchor(null); setEditScheduleId(s.id); setScheduleModalOpen(true); }}
                    >
                      <Pencil size={12} strokeWidth={1.5} />
                    </button>
                  </AppTooltip>
                )}
                <AppTooltip titleKey="kanban.card.deleteSchedule">
                <button
                  className={btnClasses.iconBtnDelete}
                  style={{ width: 22, height: 22 }}
                  onClick={async (e) => { e.stopPropagation(); try { await api.delete(`/schedules/${s.id}`); fetchSchedules(); } catch {} }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                    <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" />
                    <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" />
                    <path d="M9.5 16.5L9.5 10.5" />
                    <path d="M14.5 16.5L14.5 10.5" />
                  </svg>
                </button>
                </AppTooltip>
              </div>
            ))}
          </div>
          <div style={{
            position: "sticky", bottom: -6, padding: "6px 10px 8px 0",
            background: theme.mode === "light" ? "#ffffff" : "#121212", zIndex: 1,
          }}>
            <button
              onClick={(e) => { e.stopPropagation(); setScheduleAnchor(null); setEditScheduleId(null); setScheduleModalOpen(true); }}
              style={{
                width: "100%", padding: "7px 0", borderRadius: 8,
                border: "1px dashed rgba(128,128,128,0.3)", background: "transparent",
                color: "inherit", cursor: "pointer", fontSize: 12, fontWeight: 500, opacity: 0.6,
                display: "flex", alignItems: "center", justifyContent: "center", gap: 4,
              }}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
              {i18n.t("kanban.schedule.newScheduled")}
            </button>
          </div>
        </div>
      </ChatiaPopover>

      {/* Follow-up Dialog */}
      <Dialog
        open={followUpOpen}
        onClose={() => setFollowUpOpen(false)}
        onClick={(e) => e.stopPropagation()}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "chatia-dialog-paper", style: { borderRadius: "21px 21px 12px 12px", maxHeight: "80vh", display: "flex", flexDirection: "column", overflow: "hidden" } }}
      >
        <div className="chatia-ds-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", flexShrink: 0 }}>
          <Typography style={{ fontWeight: 600, fontSize: 15 }}>{i18n.t("kanban.followUp.title")}</Typography>
          <IconButton size="small" className="chatia-close-btn" onClick={() => setFollowUpOpen(false)}>
            <LuX size={16} />
          </IconButton>
        </div>
        <div
          ref={(el) => {
            if (el && followUpOpen) {
              requestAnimationFrame(() => { el.scrollTop = el.scrollHeight; });
            }
          }}
          style={{ flex: 1, overflowY: "auto", padding: "10px 16px 10px", minHeight: 0, scrollbarWidth: "thin", scrollbarColor: "rgba(128,128,128,0.3) transparent" }}
        >
          {/* Timeline */}
          <div style={{ position: "relative" }}>
            {(Array.isArray(followUps) ? followUps : []).length > 1 && (
              <div style={{
                position: "absolute", left: 15, top: 16, bottom: 16, width: 1,
                background: "linear-gradient(to bottom, #888, rgba(127,127,127,0.15), transparent)",
                opacity: 0.55, zIndex: 0,
              }} />
            )}
            {(Array.isArray(followUps) ? [...followUps].reverse() : []).map((f) => {
              const isPast = f.returnDate && new Date(f.returnDate) < new Date();
              const isFuture = f.returnDate && new Date(f.returnDate) >= new Date();
              const dotColor = isPast ? "#ef4444" : isFuture ? (theme.palette.primary?.main || "#1976d2") : "#66bb6a";
              return (
                <div key={f.id} style={{ display: "flex", gap: 16, paddingBottom: 28, position: "relative" }}>
                  <div
                    style={{
                      flexShrink: 0, width: 32, height: 32, borderRadius: "50%",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      background: "#111",
                      border: "1px solid rgba(127,127,127,0.2)",
                      color: "rgba(200,200,200,0.55)", zIndex: 1,
                      transition: "border-color 0.25s ease, color 0.25s ease",
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = theme.palette.primary.main; e.currentTarget.style.color = theme.palette.primary.main; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(127,127,127,0.2)"; e.currentTarget.style.color = "rgba(200,200,200,0.55)"; }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 16.4292 4.87962 20.1859 8.86884 21.5M9 14L12 12V6.66702" />
                      <path d="M13 16H15C15.5523 16 16 16.4477 16 17V18C16 18.5523 15.5523 19 15 19H14C13.4477 19 13 19.4477 13 20V21C13 21.5523 13.4477 22 14 22H16" />
                      <path d="M22 16V19M22 19H20C19.4477 19 19 18.5523 19 18V16M22 19V22" />
                    </svg>
                  </div>
                  <div style={{ flex: 1, paddingTop: 2, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 6 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        {editingFollowId === f.id ? (
                          <TextField
                            value={editingFollowNote}
                            onChange={(e) => setEditingFollowNote(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            variant="outlined"
                            size="small"
                            multiline
                            minRows={1}
                            maxRows={4}
                            autoFocus
                            inputRef={(el) => { if (el) { const len = el.value.length; el.setSelectionRange(len, len); } }}
                            fullWidth
                            style={{ margin: 0 }}
                            InputProps={{ style: { fontSize: 13, borderRadius: 10 } }}
                            onKeyDown={async (e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                if (!editingFollowNote.trim()) return;
                                try { await api.put(`/contact-follow-ups/${f.id}`, { note: editingFollowNote.trim() }); setEditingFollowId(null); fetchFollowUps(); } catch {}
                              }
                              if (e.key === "Escape") setEditingFollowId(null);
                            }}
                          />
                        ) : (
                          <div style={{ fontSize: 13, opacity: 0.75, lineHeight: 1.6, whiteSpace: "pre-wrap", wordBreak: "break-word", fontWeight: 300 }}>
                            {f.note}
                          </div>
                        )}
                        <div style={{ display: "flex", gap: 10, marginTop: 6, fontSize: 10, opacity: 0.4, letterSpacing: 0.3, flexWrap: "wrap" }}>
                          {f.user?.name && <span>{f.user.name}</span>}
                          {f.createdAt && <span>· {format(parseISO(f.createdAt), "dd/MM/yyyy HH:mm")}</span>}
                        </div>
                        {f.returnDate && (
                          <div style={{
                            marginTop: 8, padding: "4px 9px", borderRadius: 8, fontSize: 11,
                            display: "inline-flex", alignItems: "center", gap: 5,
                            background: `color-mix(in srgb, ${dotColor} 10%, transparent)`,
                            borderLeft: `2px solid ${dotColor}`,
                          }}>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={dotColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                            <span style={{ fontWeight: 600, color: dotColor }}>{isPast ? i18n.t("kanban.followUp.past") : i18n.t("kanban.followUp.upcoming")}</span>
                            <span style={{ opacity: 0.7 }}>{format(parseISO(f.returnDate), "dd/MM/yyyy 'às' HH:mm")}</span>
                          </div>
                        )}
                      </div>
                      <div style={{ display: "flex", gap: 3, flexShrink: 0, marginTop: 2 }}>
                        {editingFollowId === f.id ? (
                          <button
                            style={{ width: 18, height: 18, display: "inline-flex", alignItems: "center", justifyContent: "center", padding: 0, borderRadius: "50%", border: "none", cursor: "pointer", color: "#2e7d32", background: "rgba(46,125,50,0.15)" }}
                            onClick={async (e) => {
                              e.stopPropagation();
                              if (!editingFollowNote.trim()) return;
                              try { await api.put(`/contact-follow-ups/${f.id}`, { note: editingFollowNote.trim() }); setEditingFollowId(null); fetchFollowUps(); } catch {}
                            }}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
                          </button>
                        ) : (
                          <button
                            className={btnClasses.iconBtnEdit}
                            style={{ width: 18, height: 18 }}
                            onClick={(e) => { e.stopPropagation(); setEditingFollowId(f.id); setEditingFollowNote(f.note); }}
                          >
                            <Pencil size={9} strokeWidth={1.5} />
                          </button>
                        )}
                        <button
                          className={btnClasses.iconBtnDelete}
                          style={{ width: 18, height: 18 }}
                          onClick={async (e) => { e.stopPropagation(); try { await api.delete(`/contact-follow-ups/${f.id}`); fetchFollowUps(); } catch {} }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="9" height="9" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                            <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" />
                            <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" />
                            <path d="M9.5 16.5L9.5 10.5" /><path d="M14.5 16.5L14.5 10.5" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
          {/* Form - fixo no rodapé */}
          <div style={{ flexShrink: 0, padding: "10px 16px 4px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                label={i18n.t("kanban.followUp.whatWasDiscussedLabel")}
                value={newFollowNote}
                onChange={(e) => setNewFollowNote(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                variant="outlined"
                size="small"
                multiline
                minRows={2}
                maxRows={4}
                fullWidth
                style={{ margin: 0 }}
                InputProps={{ style: { borderRadius: 12 } }}
              />
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <DatePickerCustom
                  label={i18n.t("kanban.followUp.nextReturnLabel")}
                  value={newFollowDate ? newFollowDate.split("T")[0] : ""}
                  onChange={(dateStr) => {
                    const time = newFollowDate ? newFollowDate.split("T")[1] || "09:00" : "09:00";
                    setNewFollowDate(`${dateStr}T${time}`);
                  }}
                />
                <Autocomplete
                  freeSolo
                  size="small"
                  options={(() => {
                    const opts = [];
                    for (let h = 0; h < 24; h++) {
                      for (let m = 0; m < 60; m += 30) {
                        opts.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
                      }
                    }
                    return opts;
                  })()}
                  inputValue={newFollowDate ? newFollowDate.split("T")[1] || "09:00" : "09:00"}
                  onInputChange={(e, v, reason) => {
                    if (reason === "reset") return;
                    const digits = v.replace(/\D/g, "");
                    if (digits.length >= 4 && !v.includes(":")) {
                      const hh = Math.min(parseInt(digits.slice(0, 2), 10), 23);
                      const mm = Math.min(parseInt(digits.slice(2, 4), 10), 59);
                      const time = `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
                      const dateStr = newFollowDate ? newFollowDate.split("T")[0] : "";
                      if (dateStr) setNewFollowDate(`${dateStr}T${time}`);
                      return;
                    }
                    const dateStr = newFollowDate ? newFollowDate.split("T")[0] : "";
                    if (dateStr && v) setNewFollowDate(`${dateStr}T${v}`);
                  }}
                  onChange={(e, v) => {
                    if (v) {
                      const dateStr = newFollowDate ? newFollowDate.split("T")[0] : "";
                      if (dateStr) setNewFollowDate(`${dateStr}T${v}`);
                    }
                  }}
                  disableClearable
                  getOptionLabel={(o) => o || ""}
                  style={{ width: 110 }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label={i18n.t("kanban.followUp.timeLabel")} placeholder="09:00" style={{ margin: 0 }}
                      InputProps={{ ...params.InputProps, style: { borderRadius: 12 } }}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </div>
              <AppTooltip title={!newFollowNote.trim() ? i18n.t("kanban.followUp.fillDiscussedTooltip") : ""} disableHoverListener={!!newFollowNote.trim()}>
                <button
                  onClick={async (e) => {
                    e.stopPropagation();
                    if (!newFollowNote.trim()) return;
                    try {
                      await api.post("/contact-follow-ups", { note: newFollowNote.trim(), returnDate: newFollowDate || null, contactId: ticket.contact.id });
                      setNewFollowNote("");
                      setNewFollowDate("");
                      fetchFollowUps();
                    } catch {}
                  }}
                  className={btnClasses.actionBtn}
                  style={{
                    width: "100%", padding: "8px 0", fontSize: 12, justifyContent: "center", marginBottom: 20,
                    opacity: !newFollowNote.trim() ? 0.4 : 1,
                    cursor: !newFollowNote.trim() ? "not-allowed" : "pointer",
                    color: theme.chatiaDS.colors.textPrimary,
                    background: "rgba(128,128,128,0.08)",
                    borderColor: "rgba(128,128,128,0.2)",
                  }}
                  disabled={!newFollowNote.trim()}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
                  {i18n.t("kanban.followUp.registerButton")}
                </button>
              </AppTooltip>
            </div>
          </div>
      </Dialog>

      {/* Notes Popover */}
      <ChatiaPopover
        open={Boolean(notesAnchor)}
        anchorEl={notesAnchor}
        onClose={(e) => { if (e && e.stopPropagation) e.stopPropagation(); setNotesAnchor(null); }}
        onClick={(e) => e.stopPropagation()}
        title={i18n.t("kanban.card.notes")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        contentStyle={{ padding: 0, maxHeight: "none", overflow: "visible" }}
      >
        <div style={{ minWidth: 340, maxWidth: 420, display: "flex", flexDirection: "column", height: 380 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 6, overflowY: "auto", flex: 1, minHeight: 0, padding: "8px 6px 8px 10px", scrollbarWidth: "thin", scrollbarColor: "rgba(128,128,128,0.3) transparent" }}>
            {(Array.isArray(notes) ? notes : []).map((n) => (
              <div key={n.id} style={{
                display: "flex", alignItems: "flex-start", gap: 8, padding: "8px 10px",
                marginRight: 10, borderRadius: 8, background: "rgba(128,128,128,0.06)", fontSize: 12,
                border: theme.palette.type === "light" ? "1px solid rgba(0,0,0,0.06)" : "1px solid rgba(255,255,255,0.04)",
              }}>
                {editingNoteId === n.id ? (
                  <TextField
                    value={editingNoteText}
                    onChange={(e) => setEditingNoteText(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    variant="outlined"
                    size="small"
                    multiline
                    minRows={1}
                    maxRows={4}
                    autoFocus
                    inputRef={(el) => { if (el) { const len = el.value.length; el.setSelectionRange(len, len); } }}
                    style={{ flex: 1, margin: 0 }}
                    InputProps={{ style: { fontSize: 12, borderRadius: 10 } }}
                    onKeyDown={async (e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        if (!editingNoteText.trim()) return;
                        try { await api.put(`/ticket-notes/${n.id}`, { id: n.id, note: editingNoteText.trim() }); setEditingNoteId(null); fetchNotes(); } catch {}
                      }
                      if (e.key === "Escape") setEditingNoteId(null);
                    }}
                  />
                ) : (
                  <span style={{ flex: 1, whiteSpace: "pre-wrap", wordBreak: "break-word", lineHeight: 1.4 }}>
                    {n.note}
                  </span>
                )}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4, flexShrink: 0 }}>
                  <span style={{ fontSize: 9, opacity: 0.4 }}>
                    {n.createdAt ? format(parseISO(n.createdAt), "dd/MM HH:mm") : ""}
                  </span>
                  <div style={{ display: "flex", gap: 3 }}>
                    {editingNoteId === n.id ? (
                      <button
                        style={{ width: 20, height: 20, display: "inline-flex", alignItems: "center", justifyContent: "center", padding: 0, borderRadius: "50%", border: "none", cursor: "pointer", color: "#2e7d32", background: "rgba(46,125,50,0.15)", transition: "all 0.15s" }}
                        onClick={async (e) => {
                          e.stopPropagation();
                          if (!editingNoteText.trim()) return;
                          try { await api.put(`/ticket-notes/${n.id}`, { id: n.id, note: editingNoteText.trim() }); setEditingNoteId(null); fetchNotes(); } catch {}
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
                      </button>
                    ) : (
                      <button
                        className={btnClasses.iconBtnEdit}
                        style={{ width: 20, height: 20 }}
                        onClick={(e) => { e.stopPropagation(); setEditingNoteId(n.id); setEditingNoteText(n.note); }}
                      >
                        <Pencil size={10} strokeWidth={1.5} />
                      </button>
                    )}
                    <button
                      className={btnClasses.iconBtnDelete}
                      style={{ width: 20, height: 20 }}
                      onClick={async (e) => { e.stopPropagation(); try { await api.delete(`/ticket-notes/${n.id}`); fetchNotes(); } catch {} }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                        <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" />
                        <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" />
                        <path d="M9.5 16.5L9.5 10.5" />
                        <path d="M14.5 16.5L14.5 10.5" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ flexShrink: 0, padding: "10px 12px", background: theme.mode === "light" ? "#ffffff" : "#121212", borderTop: "1px solid rgba(128,128,128,0.12)" }}>
            <div style={{ display: "flex", gap: 4, alignItems: "flex-end" }}>
              <TextField
                label={i18n.t("kanban.notes.newLabel")}
                value={newNote}
                onChange={(e) => setNewNote(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                variant="outlined"
                size="small"
                multiline
                minRows={1}
                maxRows={3}
                style={{ flex: 1, margin: 0 }}
                InputProps={{ style: { fontSize: 12, borderRadius: 12 } }}
                InputLabelProps={{ style: { fontSize: 12 } }}
              />
              <AppTooltip title={!newNote.trim() ? i18n.t("kanban.notes.typePlaceholder") : ""} disableHoverListener={!!newNote.trim()}>
                <span style={{ display: "inline-flex" }}>
                  <button
                    onClick={async (e) => {
                      e.stopPropagation();
                      if (!newNote.trim()) return;
                      try {
                        await api.post("/ticket-notes", { note: newNote.trim(), contactId: ticket.contact.id, ticketId: ticket.id });
                        setNewNote("");
                        fetchNotes();
                      } catch {}
                    }}
                    style={{
                      background: "transparent", border: "none",
                      cursor: !newNote.trim() ? "not-allowed" : "pointer",
                      color: "inherit", opacity: !newNote.trim() ? 0.2 : 0.5, padding: 4, display: "flex",
                      alignItems: "center", flexShrink: 0, transition: "opacity 0.15s", marginBottom: 4,
                    }}
                    onMouseEnter={(e) => { if (newNote.trim()) e.currentTarget.style.opacity = "1"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.opacity = !newNote.trim() ? "0.2" : "0.5"; }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2.00012C17.5228 2.00012 22 6.47727 22 12.0001C22 17.523 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.523 2 12.0001M8.909 2.48699C7.9 2.8146 6.96135 3.29828 6.12153 3.90953M3.90943 6.12162C3.29806 6.9616 2.81432 7.90044 2.4867 8.90964"/><path d="M12 8.00012V16.0001M16 12.0001L8 12.0001"/></svg>
                  </button>
                </span>
              </AppTooltip>
            </div>
          </div>
        </div>
      </ChatiaPopover>

      {/* Chat Dialog - reusa a tela de chat sem cabeçalho/rodapé */}
      <Dialog
        open={chatDialogOpen}
        onClose={() => setChatDialogOpen(false)}
        onClick={(e) => e.stopPropagation()}
        maxWidth={false}
        fullWidth
        PaperProps={{ className: "chat-transparent", style: { width: "min(1100px, 95vw)", maxWidth: "none", height: "90vh", borderRadius: 21, overflow: "hidden", display: "flex", flexDirection: "column", margin: 0, background: "transparent", backgroundColor: "transparent" } }}
      >
        {chatDialogOpen && ticket?.uuid && (
          <div className="kanban-chat-dialog-wrapper" style={{ flex: 1, minHeight: 0, display: "flex", width: "100%" }}>
            <QueueSelectedProvider>
              <div style={{ flex: 1, display: "flex", minWidth: 0, width: "100%" }}>
                <Ticket ticketIdOverride={ticket.uuid} embedded />
              </div>
            </QueueSelectedProvider>
          </div>
        )}
      </Dialog>
      {chatDialogOpen && (
        <Portal>
          <button
            onClick={(e) => { e.stopPropagation(); setChatDialogOpen(false); }}
            aria-label={i18n.t("kanban.common.close")}
            style={{
              position: "fixed",
              top: "calc(5vh + 16px)",
              right: "calc((100vw - min(1100px, 95vw)) / 2 - 48px)",
              width: 36, height: 36,
              borderRadius: "50%", border: "none", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "rgba(255,255,255,0.15)",
              color: "#ffffff",
              zIndex: 1300,
              transition: "background 0.15s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.28)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.15)"; }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18M6 6l12 12" /></svg>
          </button>
        </Portal>
      )}

      {/* Budget Popover */}
      <ChatiaPopover
        open={Boolean(budgetAnchor)}
        anchorEl={budgetAnchor}
        onClose={(e) => { if (e && e.stopPropagation) e.stopPropagation(); setBudgetAnchor(null); }}
        onClick={(e) => e.stopPropagation()}
        title={i18n.t("kanban.card.budget")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        contentStyle={{ paddingLeft: 10, paddingRight: 0, paddingTop: 6, paddingBottom: 6 }}
      >
        <div style={{ minWidth: 440, maxWidth: 520 }}>
          {/* Total */}
          {(() => {
            const products = ticket.contact?.products || [];
            const total = products.reduce((sum, p) => sum + (Number(p.value) || 0), 0);
            return total > 0 ? (
              <div style={{ textAlign: "center", padding: "4px 10px 8px 0", borderBottom: "1px solid rgba(128,128,128,0.12)", marginBottom: 6 }}>
                <span style={{ fontSize: 10, opacity: 0.5, textTransform: "uppercase", letterSpacing: 0.5 }}>{i18n.t("kanban.budget.total")}</span>
                <div style={{ fontSize: 18, fontWeight: 700, color: "#66bb6a" }}>{fmtMoney(total)}</div>
              </div>
            ) : null;
          })()}

          {/* Products list */}
          <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 16 }}>
            {(ticket.contact?.products || []).map((p) => {
              const statusMap = {
                budget: { color: "#90a4ae", label: i18n.t("kanban.budget.statuses.budget") },
                negotiating: { color: "#42a5f5", label: i18n.t("kanban.budget.statuses.negotiating") },
                pending: { color: "#f9a825", label: i18n.t("kanban.budget.statuses.pending") },
                approved: { color: "#66bb6a", label: i18n.t("kanban.budget.statuses.approved") },
                paid: { color: "#2e7d32", label: i18n.t("kanban.budget.statuses.paid") },
                partial: { color: "#ff9800", label: i18n.t("kanban.budget.statuses.partial") },
                overdue: { color: "#ef4444", label: i18n.t("kanban.budget.statuses.overdue") },
                rejected: { color: "#c62828", label: i18n.t("kanban.budget.statuses.rejected") },
                refunded: { color: "#7e57c2", label: i18n.t("kanban.budget.statuses.refunded") },
                cancelled: { color: "#9e9e9e", label: i18n.t("kanban.budget.statuses.cancelled") },
              };
              const st = statusMap[p.status] || statusMap.pending;
              const statusColor = st.color;
              const statusLabel = st.label;
              const isEditing = editingProdId === p.id;
              const saveEdit = async (e) => {
                if (e && e.stopPropagation) e.stopPropagation();
                if (!editingProdName.trim()) return;
                const value = editingProdValue
                  ? unmaskCurrencyInput(editingProdValue, currencyInfo?.code || "BRL")
                  : null;
                try {
                  await api.put(`/contacts/${ticket.contact.id}/products/${p.id}`, {
                    name: editingProdName.trim(),
                    status: editingProdStatus,
                    value,
                  });
                  setEditingProdId(null);
                  if (onRefresh) onRefresh();
                } catch (err) {
                  toastError(err);
                }
              };
              return (
                <div key={p.id} style={{
                  display: "flex", alignItems: "center", gap: 8, padding: "6px 10px",
                  marginRight: 10, borderRadius: 8, background: "rgba(128,128,128,0.06)", fontSize: 12,
                  border: theme.palette.type === "light" ? "1px solid rgba(0,0,0,0.06)" : "1px solid rgba(255,255,255,0.04)",
                }}>
                  <span style={{ width: 6, height: 6, borderRadius: "50%", flexShrink: 0, background: statusColor }} />
                  {isEditing ? (
                    <>
                      <TextField
                        value={editingProdName}
                        onChange={(e) => setEditingProdName(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        variant="outlined"
                        size="small"
                        autoFocus
                        style={{ flex: 1, margin: 0, minWidth: 0 }}
                        InputProps={{ style: { fontSize: 12, borderRadius: 10, height: 28 } }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") { e.preventDefault(); saveEdit(); }
                          if (e.key === "Escape") setEditingProdId(null);
                        }}
                      />
                      <TextField
                        value={editingProdValue}
                        onChange={(e) => setEditingProdValue(maskCurrencyInput(e.target.value, currencyInfo?.code || "BRL"))}
                        onClick={(e) => e.stopPropagation()}
                        variant="outlined"
                        size="small"
                        placeholder={currencyInfo?.symbol || "R$"}
                        style={{ width: 80, margin: 0 }}
                        InputProps={{ style: { fontSize: 12, borderRadius: 10, height: 28 } }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") { e.preventDefault(); saveEdit(); }
                          if (e.key === "Escape") setEditingProdId(null);
                        }}
                      />
                      <ChatiaSelect
                        value={editingProdStatus}
                        onChange={(e) => setEditingProdStatus(e.target.value)}
                        fullWidth={false}
                        style={{ minWidth: 100, fontSize: 11, height: 28 }}
                        inputProps={{ style: { padding: "2px 6px", fontSize: 11, height: 28, boxSizing: "border-box" } }}
                        options={[
                          { value: "budget", label: i18n.t("kanban.budget.statuses.budget") },
                          { value: "negotiating", label: i18n.t("kanban.budget.statuses.negotiating") },
                          { value: "pending", label: i18n.t("kanban.budget.statuses.pending") },
                          { value: "approved", label: i18n.t("kanban.budget.statuses.approved") },
                          { value: "paid", label: i18n.t("kanban.budget.statuses.paid") },
                          { value: "partial", label: i18n.t("kanban.budget.statuses.partial") },
                          { value: "overdue", label: i18n.t("kanban.budget.statuses.overdue") },
                          { value: "rejected", label: i18n.t("kanban.budget.statuses.rejected") },
                          { value: "refunded", label: i18n.t("kanban.budget.statuses.refunded") },
                          { value: "cancelled", label: i18n.t("kanban.budget.statuses.cancelled") },
                        ]}
                      />
                    </>
                  ) : (
                    <>
                      <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {p.name}
                      </span>
                      <span style={{ fontSize: 10, opacity: 0.5, flexShrink: 0 }}>{statusLabel}</span>
                      <span style={{ fontWeight: 600, flexShrink: 0, color: statusColor }}>
                        {p.value ? fmtMoney(p.value) : "—"}
                      </span>
                    </>
                  )}
                  <div style={{ display: "flex", gap: 3, flexShrink: 0, marginLeft: 4 }}>
                    {isEditing ? (
                      <>
                        <button
                          style={{ width: 20, height: 20, display: "inline-flex", alignItems: "center", justifyContent: "center", padding: 0, borderRadius: "50%", border: "none", cursor: "pointer", color: "#2e7d32", background: "rgba(46,125,50,0.15)", transition: "all 0.15s" }}
                          onClick={saveEdit}
                          title={i18n.t("kanban.common.save", { defaultValue: "Salvar" })}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
                        </button>
                        <button
                          style={{ width: 20, height: 20, display: "inline-flex", alignItems: "center", justifyContent: "center", padding: 0, borderRadius: "50%", border: "none", cursor: "pointer", color: "#666", background: "rgba(128,128,128,0.15)", transition: "all 0.15s" }}
                          onClick={(e) => { e.stopPropagation(); setEditingProdId(null); }}
                          title={i18n.t("kanban.common.cancel", { defaultValue: "Cancelar" })}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                        </button>
                      </>
                    ) : (
                      <button
                        className={btnClasses.iconBtnEdit}
                        style={{ width: 20, height: 20 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditingProdId(p.id);
                          setEditingProdName(p.name || "");
                          setEditingProdValue(p.value ? maskCurrencyInput(String(p.value), currencyInfo?.code || "BRL") : "");
                          setEditingProdStatus(p.status || "budget");
                        }}
                        title={i18n.t("kanban.common.edit", { defaultValue: "Editar" })}
                      >
                        <Pencil size={10} strokeWidth={1.5} />
                      </button>
                    )}
                    <button
                      className={btnClasses.iconBtnDelete}
                      style={{ width: 20, height: 20 }}
                      onClick={async (e) => {
                        e.stopPropagation();
                        try {
                          await api.delete(`/contacts/${ticket.contact.id}/products/${p.id}`);
                          if (editingProdId === p.id) setEditingProdId(null);
                          if (onRefresh) onRefresh();
                        } catch (err) {
                          toastError(err);
                        }
                      }}
                      title={i18n.t("kanban.common.delete", { defaultValue: "Excluir" })}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                        <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" />
                        <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" />
                        <path d="M9.5 16.5L9.5 10.5" />
                        <path d="M14.5 16.5L14.5 10.5" />
                      </svg>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Add product form */}
          <div style={{ position: "sticky", bottom: -6, padding: "6px 10px 8px 0", background: theme.mode === "light" ? "#ffffff" : "#121212", zIndex: 1 }}>
            <div style={{ display: "flex", gap: 4, alignItems: "center", height: 32 }}>
              <TextField
                label={i18n.t("kanban.budget.productLabel")}
                value={newProdName}
                onChange={(e) => setNewProdName(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                variant="outlined"
                size="small"
                style={{ flex: 1, minWidth: 0, margin: 0 }}
                InputProps={{ style: { fontSize: 12, borderRadius: 12 } }}
                InputLabelProps={{ style: { fontSize: 12 } }}
              />
              <TextField
                label={`${i18n.t("kanban.budget.valueLabel")} (${currencyInfo?.symbol || "R$"})`}
                value={newProdValue}
                onChange={(e) => {
                  const masked = maskCurrencyInput(e.target.value, currencyInfo?.code || "BRL");
                  setNewProdValue(masked);
                }}
                onClick={(e) => e.stopPropagation()}
                variant="outlined"
                size="small"
                style={{ width: 120, margin: 0 }}
                InputProps={{
                  style: { fontSize: 12, borderRadius: 12 },
                  endAdornment: isSuper ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                      fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
                      style={{ cursor: "pointer", opacity: 0.4, flexShrink: 0 }}
                      onClick={(e) => { e.stopPropagation(); setCurrencyAnchor(e.currentTarget); setCurrencySearch(""); }}
                      onMouseEnter={(e) => { e.currentTarget.style.opacity = "1"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.opacity = "0.4"; }}
                    >
                      <path d="M12.22 2h-.44a2 2 0 00-2 2v.18a2 2 0 01-1 1.73l-.43.25a2 2 0 01-2 0l-.15-.08a2 2 0 00-2.73.73l-.22.38a2 2 0 00.73 2.73l.15.1a2 2 0 011 1.72v.51a2 2 0 01-1 1.74l-.15.09a2 2 0 00-.73 2.73l.22.38a2 2 0 002.73.73l.15-.08a2 2 0 012 0l.43.25a2 2 0 011 1.73V20a2 2 0 002 2h.44a2 2 0 002-2v-.18a2 2 0 011-1.73l.43-.25a2 2 0 012 0l.15.08a2 2 0 002.73-.73l.22-.39a2 2 0 00-.73-2.73l-.15-.08a2 2 0 01-1-1.74v-.5a2 2 0 011-1.74l.15-.09a2 2 0 00.73-2.73l-.22-.38a2 2 0 00-2.73-.73l-.15.08a2 2 0 01-2 0l-.43-.25a2 2 0 01-1-1.73V4a2 2 0 00-2-2z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  ) : undefined,
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
              />
              <ChatiaSelect
                value={newProdStatus}
                onChange={(e) => setNewProdStatus(e.target.value)}
                fullWidth={false}
                style={{ minWidth: 110, fontSize: 12, height: 32 }}
                inputProps={{ style: { padding: "4px 8px", fontSize: 12, height: 32, boxSizing: "border-box" } }}
                options={[
                  { value: "budget", label: i18n.t("kanban.budget.statuses.budget") },
                  { value: "negotiating", label: i18n.t("kanban.budget.statuses.negotiating") },
                  { value: "pending", label: i18n.t("kanban.budget.statuses.pending") },
                  { value: "approved", label: i18n.t("kanban.budget.statuses.approved") },
                  { value: "paid", label: i18n.t("kanban.budget.statuses.paid") },
                  { value: "partial", label: i18n.t("kanban.budget.statuses.partial") },
                  { value: "overdue", label: i18n.t("kanban.budget.statuses.overdue") },
                  { value: "rejected", label: i18n.t("kanban.budget.statuses.rejected") },
                  { value: "refunded", label: i18n.t("kanban.budget.statuses.refunded") },
                  { value: "cancelled", label: i18n.t("kanban.budget.statuses.cancelled") },
                ]}
              />
              {(() => {
                const missingName = !newProdName.trim();
                const missingValue = !newProdValue;
                const disabled = missingName && missingValue;
                const tooltipMsg = disabled
                  ? i18n.t("kanban.budget.fillProductBoth")
                  : "";
                return (
                  <AppTooltip title={tooltipMsg} disableHoverListener={!disabled}>
                    <span style={{ display: "inline-flex" }}>
                      <button
                        type="button"
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={async (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (disabled) return;
                          const value = newProdValue ? unmaskCurrencyInput(newProdValue, currencyInfo?.code || "BRL") : null;
                          const name = newProdName.trim() || i18n.t("kanban.budget.statuses.budget");
                          try {
                            await api.post(`/contacts/${ticket.contact.id}/products`, { name, status: newProdStatus, value });
                            setNewProdName("");
                            setNewProdValue("");
                            setNewProdStatus("budget");
                            if (onRefresh) onRefresh();
                          } catch (err) {
                            toastError(err);
                          }
                        }}
                        style={{
                          background: "transparent", border: "none",
                          cursor: disabled ? "not-allowed" : "pointer",
                          color: "inherit", opacity: disabled ? 0.2 : 0.5, padding: 4, display: "flex",
                          alignItems: "center", flexShrink: 0,
                          transition: "opacity 0.15s",
                        }}
                        onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.opacity = "1"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.opacity = disabled ? "0.2" : "0.5"; }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2.00012C17.5228 2.00012 22 6.47727 22 12.0001C22 17.523 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.523 2 12.0001M8.909 2.48699C7.9 2.8146 6.96135 3.29828 6.12153 3.90953M3.90943 6.12162C3.29806 6.9616 2.81432 7.90044 2.4867 8.90964"/><path d="M12 8.00012V16.0001M16 12.0001L8 12.0001"/></svg>
                      </button>
                    </span>
                  </AppTooltip>
                );
              })()}
            </div>
          </div>
        </div>
      </ChatiaPopover>

      {/* Currency Popover */}
      <ChatiaPopover
        open={Boolean(currencyAnchor)}
        anchorEl={currencyAnchor}
        onClose={() => setCurrencyAnchor(null)}
        onClick={(e) => e.stopPropagation()}
        title={i18n.t("kanban.currency.title")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        contentStyle={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0 }}
      >
        <div style={{ width: 300 }}>
          <div style={{ position: "sticky", top: 0, zIndex: 1, padding: "8px 10px", background: theme.mode === "light" ? "#ffffff" : "#121212" }}>
            <TextField
              placeholder={i18n.t("kanban.currency.searchPlaceholder")}
              value={currencySearch}
              onChange={(e) => setCurrencySearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              variant="outlined"
              size="small"
              fullWidth
              autoFocus
              style={{ margin: 0 }}
              InputProps={{ style: { fontSize: 12, borderRadius: 10 } }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 1, padding: "4px 6px 8px" }}>
            {(getAvailableCurrencies?.() || [])
              .filter((c) => {
                if (!currencySearch) return true;
                const q = currencySearch.toLowerCase();
                return c.name.toLowerCase().includes(q) || c.code.toLowerCase().includes(q) || c.symbol.toLowerCase().includes(q);
              })
              .map((c) => (
                <button
                  key={c.code}
                  onClick={async () => { await updateCurrency(c.code); setCurrencyAnchor(null); }}
                  style={{
                    display: "flex", alignItems: "center", gap: 8, padding: "6px 10px",
                    borderRadius: 8, border: "none", cursor: "pointer", fontSize: 12,
                    background: currencyInfo?.code === c.code ? `color-mix(in srgb, ${theme.palette.primary?.main || "#1976d2"} 15%, transparent)` : "transparent",
                    color: currencyInfo?.code === c.code ? (theme.palette.primary?.main || "#1976d2") : "inherit",
                    fontWeight: currencyInfo?.code === c.code ? 600 : 400,
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={(e) => { if (currencyInfo?.code !== c.code) e.currentTarget.style.background = "rgba(128,128,128,0.08)"; }}
                  onMouseLeave={(e) => { if (currencyInfo?.code !== c.code) e.currentTarget.style.background = "transparent"; }}
                >
                  <span style={{ width: 28, fontWeight: 600, fontSize: 11, opacity: 0.6, textAlign: "center" }}>{c.symbol}</span>
                  <span style={{ flex: 1 }}>{c.name}</span>
                  <span style={{ fontSize: 10, opacity: 0.4 }}>{c.code}</span>
                </button>
              ))}
          </div>
        </div>
      </ChatiaPopover>

      {/* Schedule Modal */}
      {scheduleModalOpen && (
        <ScheduleModal
          open={scheduleModalOpen}
          onClose={() => { setScheduleModalOpen(false); setEditScheduleId(null); fetchSchedules(); }}
          contactId={ticket.contact?.id}
          scheduleId={editScheduleId}
        />
      )}
    </div>
  );
});

export default Kanban;
